function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthAmericaUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Map-northamerica-usa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.5,
    height: 199.589,
    viewBox: "0 0 400.5 199.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yfdcant25a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2394",
    transform: "translate(.249 .249)",
    style: {
      fill: "none"
    },
    d: "M0 0h400v199.09H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y2qah60fbb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2396",
    style: {
      fill: "none"
    },
    d: "M0 0h400.5v199.589H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2647"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3451"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2645"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2644",
    style: {
      clipPath: "url(#yfdcant25a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2643"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2642",
    style: {
      clipPath: "url(#yfdcant25a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2066",
    d: "m398.459 173.189 1.79 2.38-6.21 4.42.85-2.72 2.55-2.55v-3.83l1.02-.42z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2067",
    d: "m392.289 123.489-1.38.47-3.44-2.47 1.32-.09z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2068",
    d: "M391.489 179.649v1.7l-9.95 6.55-2.98-1.7z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2069",
    d: "M389.749 123.949v1.72l-2.96 1.66-1.7-1.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2070",
    d: "m387.459 133.129-3.83-.78-4.2-4.1-3.24 2.98-1.7-.6v-9.17l8.45 4.42-.23 2.51z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2071",
    d: "m370.649 145.969 6.64 9.35-.68 7.06-12.08 12.5-10.46-.6-1.28-7.06-3.57 1.53-3.4-2.97-20.67 4.52-1.28-1.53 1.7-4.09V152.6l10.89-5.1 8.08-8.93 4.42 1.96 1.96-4.08 7.4-.17-1.87 3.4 6.12 5.27 4.08-4.08v-5.7l1.88.59z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2072",
    d: "M374.489 121.459v9.17l-4.66-1.62 1.81-1.1-.98-2.79-5.44-2.27-2.2.08.42-2.05 3.73 1.47 3.53-2.87 3.79 1.97z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2073",
    d: "m365.009 118.209.47 2.53-4.37-1.98z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2074",
    d: "m362.709 52.279-1.06 1.82-2.5.03-.78 1.06-1.1-.65-.11-4.59z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2075",
    d: "M359.779 121.249v.92l-3.56.37.37-1.29z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2076",
    d: "m357.409 112.959.59.72-.96 1.19.37 2.59-1.64-.4.45-2.92z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2077",
    d: "m354.369 44.329 2.83 4.02h-1.69l-2.28-4.25-4.66-5.75 1.64.05 5.8 5.93z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2078",
    d: "m359.149 65.249-.13 1.68-1.25.53-.43-2.12-5.5.81.41-1.41 4.6-1.19 3.4-3.09-.95-4.39 1.67.49 1.67 2.92.2 4.83z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2079",
    d: "m356.589 66.529-.96 1.74-1.27-1.44z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2080",
    d: "m353.269 67.209.65.96-.72 2.26-1.92-2.97z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2081",
    d: "m352.229 98.579 1.44 2.31h-1.51l-1.38-1.78z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2082",
    d: "m351.479 106.919-2.74-1.95h3.29l1-2.62 1.36 4.24-1.6.41.67 1.22-1.98.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2083",
    d: "M351.819 129.839h3.53v.97l-2.6.31-.93-1.27z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2084",
    d: "m351.819 129.849.93 1.27-1.44 1.29-1.61-.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2085",
    d: "m350.779 100.609.78 1.36-.62.82-1.09-1.64z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2086",
    d: "m349.139 101.979.71 1.07-.71.85-.8-.99z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2087",
    d: "m349.009 62.309-.45 3.06-2.66.19-2.19-4.75 1.62-1.5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2088",
    d: "m348.909 130.119-.85.69h-2.02l-.41-1.37h2.12z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2089",
    d: "m347.039 100.849.64-1.16 1.46.18-1.1 1.66z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2090",
    d: "m347.039 98.839-.46.85-1.14-1.11.19-1.13z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2091",
    d: "m347.2 118.709 3.22-.13-2.02 1.69 1.07 2.35v1.48l-1.89-.66-.78-2.06-.93 1.03.48 2.78-1.58.48-.79-4.03 1.26-1.69-.15-3.11 2.18-1.97 3.29.8 1-.65 1.53.03-1.74 2.06-1.17.1-2.36-.81-1.28 1.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2092",
    d: "m346.8 97.309-2.82-3.39.49-4.25 1.99.04 1.09 2.41-1.1 2.52 1.1 1.37 3.02.32-.47 1.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2093",
    d: "m345.629 131.319.51 1.1h-1.47l-.62-.76z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2094",
    d: "M345.439 53.5v.01h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2095",
    d: "m342.169 55.759 3.26-2.25h.01l.37 4.19-2.1.28 1.62 1.33-1.62 1.5-2.09-.59-1.58-2.99z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2096",
    d: "m344.719 100.539.05 1.62-2.38 1.97-1.33-.26z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2097",
    d: "m343.619 79.439 1.12 1.17-1.12 3.14-1.83-1.71z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2098",
    d: "M343.069 110.349v.01l-2.37.24z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2099",
    d: "m342.169 55.759-2.13 1.47v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2100",
    d: "m338.989 129.439.2.95-13.7-2.32 2.06-1.65 3.42 1.3 3.08-.68z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2101",
    d: "m340.629 107.769 2.44-.2v2.78l-2.37.25-1.92 3.63-6.44 1.44-1.39-.84 6.76-3.12z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2102",
    d: "m332.339 115.669 6.44-1.44 1.92-3.63 2.37-.24v7.62l-3.29 4.2h-6.65l-2.09-3.66-.13-3.68.04-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2103",
    d: "M330.419 87.449v1.24l-1.3 1.62-.89-1.08v-1.29z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2104",
    d: "M329.909 37.579h-6.37v-.01h6.38l6.58 6.44 8.94 2.28V53.5l-.01.01V46.3l-8.95-2.28z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2105",
    d: "M327.549 46.289v.01l-3.84-.62z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2106",
    d: "m327.179 48.349-5.52 1.15-2.05 4.19-17.08-.19-14.76-8.62 4.51-3.44 6.07 1.85.01-.01h.01l1.63-3.69 14.93 3.7h7.32l1.46 2.39 3.84.62z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2107",
    d: "M327.339 96.019V99.1l-2.74 2.05-1.85.26-1.64-1.63v-2.73l1.03-1.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2108",
    d: "M326.179 121.629v2.81l-2.01 1.67-12.7-17.29 3.75 1.43z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2109",
    d: "m320.069 107.5 4.56 6.73-.38 1.47-4.83-4.12-1.17-3.81 1.81-.27z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2110",
    d: "m327.339 94.689-1.85-1.97-2.53-2.69-.68-.72V89.3l-1.13-3.47-3.52-1.72 4.62-2.34 4.23 3.62-1.95 1.11-.27 3.17 5.48 5.8.18 5.16-5.25 3.47-.07-2.95 2.74-2.05v-4.41z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2111",
    d: "m325.489 92.719 1.85 1.97v1.33h-5.2l2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06v-1.45l1.86-.94 3.52 1.72 1.12 3.47.01.01.68.72z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2112",
    d: "M322.249 43.279v.01h-7.32L300 39.589l.01-.01 14.93 3.7z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2380",
    transform: "translate(317.579 87.559)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v2.75H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2113",
    d: "m317.819 96.519-.68 6.67 2.92 4.31-1.81.27h-.01l-.29-.93-3.01-2.56.1-1.68.01-.02v.02l1.72-3.38-3.1-11.19 2.09-1.53h.01l1.81 1.06v2.75h4.4l2.48 3.38-2.32 2.33-1.03 1.03v2.73z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2114",
    d: "m316.769 99.219-1.72 3.38v-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2115",
    d: "m312.069 78.889 3.7 6.16h-.01l-3.7-6.16.96-2.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2381",
    transform: "translate(315.759 85.049)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v1.45H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2116",
    d: "m315.759 86.5-2.09 1.53v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2117",
    d: "m313.669 88.029 3.1 11.19-1.72 3.36.26-4.25L314.2 94.2l-2.01-2.26-1.08 1.35-1.51-.45-.81-4.27-2.14-1.79.31-2.12v-.01l1.05-7.22 2.86-2.06h.01l2.14.92-.96 2.6 3.7 6.16v1.45l-2.09 1.52z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2118",
    d: "m310.879 75.359-.01.01-4.84-2.09.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2119",
    d: "m308 77.439.01-.01-1.05 7.22z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2120",
    d: "m302.759 76.279-.01.01L299.6 75.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2121",
    d: "m302.749 76.289-.68 1.42-1.53-.38L299.2 77l.4-1.8z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2122",
    d: "m304.469 82.319 2.49 2.34-.31 2.12-4.74-3.98-1.07 1.03-1.65-5.21 1.17-.55 1.71 2.28 1.99-.82z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2123",
    d: "m304.059 79.529-1.99.82-1.71-2.28.18-.74 1.53.38.68-1.42.01-.01 3.27-3 4.84 2.09-2.86 2.06-.01.01-1.04 7.21-2.49-2.33z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2124",
    d: "m275.529 82.969-2.71-.86-.27-.32 3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41v-.01l-1.75-.99.08-1.75 2.89-2.05h1.95l2.1.96.27 5.48h.01l2.41.84-.02 3.08 9.67 3.66 1.76-2.8.82.29-.4 1.8h.01l1.34.33-.18.74-1.17.54v.01l1.65 5.21-10.01 9.67-.68 7.99-4.39 2.7-6.91-19.88-.849-.01-.38 1.78-2.16-.25-1.2-1.56z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2125",
    d: "m298.769 74.909-1.76 2.8-9.67-3.66.03-3.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2126",
    d: "m298.769 74.909-11.4-3.94v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2127",
    d: "m298.359 43.279-.01.01-6.07-1.85.02-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2128",
    d: "M287.759 44.879v.01l-6.38 4.86-.01.01 1.07 4.93-4.09-1.89-.01-.01-6.4.28-2.71 2.23-2.77.12-2.88-3.79-3.93.75-.46-.31-4.24-2.91-3.56.83.4 5.01-2.31-1.93-2.61.72-2.05-1.7.09-2.24 3.11-1.51-2.56-1.73-4.3 1.73-2.01-2.51V40.9h14.98v-.01h.02v-3.83l8.44-1.89 21.47 7.57 3.68 2.15z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2129",
    d: "M287.369 70.959v.01h-.01v-.01l-2.41-.83-.28-5.48-2.1-.96h-.01l-4.05-1.85-.63-.29-1.26-3.09-.57-1.39 6.39-2.37v-.01l-1.06-4.94 6.38-4.86 14.77 8.62 17.08.18 2.06-4.18 5.51-1.16.37-2.05v-.01l-3.84-.61-1.46-2.39v-.01l2.72-.54v-.01h.02l-1.45-5.15h6.37l6.57 6.44 8.95 2.28v7.21l-3.26 2.25-2.13 1.46v.01l-2.81 1.93-2.01-3.83-2.92 2.56 2.3 3.77 1.17-.76h3.66l-3.18 3.47 6.19 10.19-3.47 7.77-10.62 3.79-.06-1.74-1.8 1.02-.01-.01-4.23-3.62-4.62 2.34-1.86.94-3.7-6.16.95-2.6-2.14-.92h-.01l.01-.01-4.84-2.09-.01.01-3.27 3L299.6 75.2h-.01l-.82-.29z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2130",
    d: "M287.359 70.959v.01l-2.41-.84z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2131",
    d: "m284.669 64.649.28 5.48h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2132",
    d: "m281.379 49.749 1.06 4.94-1.07-4.93z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2133",
    d: "m278.509 61.839 4.05 1.85h-1.94l-2.89 2.05-.08 1.75 1.75 1 .84 3.41-3.8 3.5H274v2.59l1.82.69v2.23l-3.28.87-1.97-2.24h-7.49l1.73-2.97-1.91-2.4-.33-.93-.1-.28 5.36.05 4.99-4.61v-.01l1.37-5.93z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2134",
    d: "m276.619 58.459 1.26 3.09h-.01l-1.26-3.09z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2135",
    d: "M276.619 58.459h-.01l-.57-1.39h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2136",
    d: "M275.819 78.669v.01l-1.82-.69z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2137",
    d: "m275.819 80.909-3.27.88h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2138",
    d: "m273.309 59.959.88 2.5-1.37 5.93-4.99 4.62-5.36-.05-2.31-6.73 1.09-2.33 5.34-2.74h.01l2.87.77h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2139",
    d: "M274 75.4h2.44l3.8-3.5v.01l-3.8 3.5h-2.43l-.01 2.58z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2140",
    d: "m278.509 61.839-4.32.62-.88-2.5-3.83 1.97-1.31-3.85 1.34-.39 3.44 1.12 3.66-.35 1.26 3.09h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2141",
    d: "M272.819 68.389v.01l-4.99 4.61z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2142",
    d: "m271.939 53.079 6.41-.28 4.09 1.89v.01l-6.39 2.37h-.01l.57 1.39-3.66.35-3.44-1.12 2.75-.79h.01l.23-1.74h-.02l-3.24.15z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2143",
    d: "m262.609 35.149 21.48 7.58 3.67 2.14v.01l-.02.01-3.68-2.15-21.47-7.57-8.44 1.89z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2144",
    d: "m239.679 58.7 1.92-.18 2.66-.27 2.33 4.11h4.23l.06-1.47 3.32-1.1 5.61 1.78.89 1.44.55.89-1.1 2.32.01.01 2.31 6.73.1.28.32.93 1.92 2.4-1.73 2.97H260.7l-8.58-2.56-4.66-4.87-2.01-.19-6.76-11.47V58.8z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2145",
    d: "m259.649 52.389 3.92-.75 2.88 3.79 2.78-.12h.01l3.24-.15-.22 1.74-2.75.79-1.34.39h-.01l1.31 3.85-2.87-.77h-.01l-8.8-7.05h-3.73l-2.27.9V55l-.4-5.01 3.56-.82 4.24 2.9z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2146",
    d: "m256 83.639-1.71-.23.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2147",
    d: "M256 87.559v-3.92l-1.7-.24 3.13-3.19 3.86 3.43-6.97 8.64-2.11-1.43v-2.27z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2148",
    d: "m254.3 83.4-.01.01-.8-.12z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2382",
    transform: "translate(239.149 40.889)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h14.98v.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2149",
    d: "m253.739 81.469 2.26-2.54 1.43 1.28L254.3 83.4l-.81-.11-1.42-.2-1.19-2.19z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2150",
    d: "m252.209 90.849 2.11 1.44-13.85 6.24-1.88-6.16 1.1-1.9 3.78.48-.35 1.43v.01l5.35-2.81 3.74-1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2151",
    d: "m251.029 57.249-4.16-3.45 2.61-.72 2.31 1.93 2.27-.9h3.73l8.8 7.05-5.34 2.74-.55-.89-.88-1.44h-.01l-5.61-1.78-3.32 1.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2152",
    d: "m250.759 79.539-.76.78-1.16-.77.59-1.88z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2153",
    d: "m249.879 136.3-5.89 18.9-3.47-.15-1.44-3.42 1.17-3.29.68-4.93 6.85-7.11z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2154",
    d: "m246.049 105.389-6.67 5.56h-8.03l-.91-.95-.01-.01-4.71-4.93 4.07-9.62h5.76l2.34 3.7-.89.74 3.02 3.37z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2155",
    d: "m243.849 71.769 1.6 2.6h-1.32l-.93-1.22H242l.34-1.38z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2156",
    d: "m242.409 54.989 1.85 3.26-2.67.26-2.44-2.23 1.25-1.79 1.99.5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2157",
    d: "m244.259 58.249-2.66.27-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2158",
    d: "M242.389 54.979v.01l-1.99-.5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2159",
    d: "m240.609 73.139-8.07-4.21-.02-.08-.39-1.63 2.23-1.34 1.22-4.8 3.07-.62 6.66 11.3-2.97.01-.34 1.38z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2160",
    d: "m241.6 58.519-1.92.18 1.91-.19z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2161",
    d: "M240.4 54.489h-.02l-4.62-2.1h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2162",
    d: "m246.049 105.389-6.03-2.14-1.51-1.7 1.49-1.07.54.92 10.25-1.52.6 3.01-14.75 17.16v-6.82l2.73-2.28h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2163",
    d: "m240 100.479-1.49 1.07-1.51-1.67.89-.74.89-.75.49.84z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2164",
    d: "m232.849 88.209 5.93 10.18-.89.75-2.34-3.7h-5.76v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2165",
    d: "m239.149 56.279 2.44 2.23-1.91.19-.99.1-1.17-2.52z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2166",
    d: "M238.649 58.8v1.65l-3.07.62-2.7.55-4.75.97-10.71-.59-2.33-4.68 2.83.02.5-.59.76-.91 14.66-.48 3.63.92z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2167",
    d: "M235.579 61.069v.01l-2.7.54z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2168",
    d: "m235.579 61.079-1.22 4.8-2.23 1.33-2.75 1.64-1.65-1.15 1.24-2.3-1.35-.47.5-2.33 4.76-.98z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2169",
    d: "m234.949 52.559-.93.21v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2170",
    d: "m234.149 122.949-7.07-4.66v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2171",
    d: "m234.019 52.769.02.03-.07-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2172",
    d: "m234.039 52.8-.02-.03.93-.21.8-.17h.01l4.62 2.1h.02l-1.25 1.79h-1.63l-.05-.01-3.58-.91v-2.57l.08-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2173",
    d: "M234.019 52.759v.01l-.05.01v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2174",
    d: "M233.969 52.769v.01l-.08.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2175",
    d: "m231.119 69.449-.53 3.08.52-3.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2176",
    d: "m230.089 44.629.42-.94-1.09-.44v-.01l1.11.45-.43.96z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2177",
    d: "m230.439 110 .91.95h8.02l-2.73 2.28h-.01v6.82l-2.48 2.9-7.07-4.67 1.16-2.03v-.01l.36-2.7-.74-3.18z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2178",
    d: "m230.429 109.989-7.44 1.05-4.2-1.53-.01-.01h.02l-7.84-9v-5.11l2.21-2.18V93.2l.22-4.96.2-4.6h13.1l2.63-1.51 3.53 6.07v.01l-3.06 7.22v.01l-4.08 9.61.01.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2179",
    d: "m229.419 43.249 1.09.44-.42.94-.08-.16.35-.78-.89-.36-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2180",
    d: "m230.359 43.689-.35.78-.01-.02.34-.76-.87-.36z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2181",
    d: "m230.339 43.689-.34.76-.53-1.12z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2182",
    d: "m230.1 44.649-.87 1.96h-.02l.88-1.98z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2183",
    d: "m230 44.449.01.02-.95 2.14h-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2184",
    d: "m229.469 43.329-8.39-3.41.01-.01 8.37 3.41z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2185",
    d: "m229.419 43.249.04.07-8.37-3.41.09-.02h.01l8.23 3.35z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2186",
    d: "m229.419 43.239-8.23-3.35h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2187",
    d: "m229.379 68.849 2.75-1.64v.01l.39 1.63-.07.03-1.33.57h-.01l-.52 3.08-1.72.8-1.14-.14V67.7z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2188",
    d: "m229.229 46.609.87-1.96 3.92 8.11-.05.01-5.38-1.88-.27-2.4 1.51-.41-.62-1.46v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2189",
    d: "M229.209 46.609v.01l-.16.03-.01-.03v-.01h.02l.95-2.14.08.16z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2190",
    d: "m228.869 73.329 1.72-.8.53-3.08 1.33-.57.09.05 8.07 4.21 1.39.01h1.19l.94 1.22v.01h1.32l3.02 4.93.37.24 1.16.77.88.58 1.19 2.19 1.42.2.8.12 1.71.23v3.92l-3.79 1.02-3.74 1-5.35 2.8.35-1.43-3.78-.48-1.1 1.9-.22-.69-10.64-18.49z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2191",
    d: "m228.6 113.539-.36 2.7h-2.52l-.97 1.69h-3.4l1.64-6.89 4.87-.68z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2192",
    d: "m229.209 46.619.62 1.46-1.51.41.27 2.4 5.38 1.88-.08.02v.01h-.02l-5.45-1.91-.27-2.4 1.51-.41-.61-1.43z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2193",
    d: "m227.129 67.259.49-2.33 1.35.47-1.24 2.3z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2194",
    d: "m227.129 67.269.6.43v5.49l-.03.07-1.52-2.48z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2195",
    d: "M227.6 139.379v.01l-.23-.19z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2196",
    d: "m229.429 140.989-1.83 1.6v-3.21l-.23-.18-1.6-1.32-.05.04v-6.88h1.78v5.93l1.93 1.28z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2197",
    d: "m225.769 137.879 1.6 1.32-1.6-1.31-.05.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2198",
    d: "m225.119 156.379-1.56.03V150.8l2.16-5.05v-3.16l-3.46-2.26 3.46-2.41.05-.03 1.6 1.31.23.19v3.2l1.83-1.6v-2.74l-1.93-1.28v-2.2h.01l7.56-1.57.75 7.11-7.6 6.24.24 6.81-3.24 2.26z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2199",
    d: "m226.879 18.619-2.93 1.46-.14-.01 2.9-1.44-11.48-3.67.15-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2200",
    d: "m214.239 69.149 11.94 1.63 1.52 2.48-.03.07-.8 1.89L223.9 72.8l5.42 9.33-2.63 1.5H213.6l.64-14.47z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2201",
    d: "m226.069 21.359-6.03 2.47-.03-.06 15.65-6.42 16.9-.46-2.1-4.78 4.37.34 2.47 8.09 2.74-2.83-3.17-3.93 14.49-6.48H287.8l1.1 3.93h17.81l3.28 2.46h7.88l2.74-2.46 9.73 1.59 1.57 2.13 27.9.8 18 3.56 2.81 3.01-3.5-.07-5.16-1.06-2.24 1.75 5.76 1.57-.14 1.17-11.47 3.63 4.84 4.66v7.85l-8.58-8.12.26-4.31 2.11-1.45-2.19-2.1-1.26-.13-.02 1.89-5.08-1.92-1.31 4.09-12.05-.09-1 7.21 5.84.09 6.03 6.85v5.85l-2.11 3.15-3.91.68v-7.22l-8.94-2.28-6.58-6.44h-6.38v.01h-.03l1.46 5.15v.01l-2.72.54h-7.31l-14.93-3.7-.01.01h-.01l-1.63 3.69-6.06-1.85-.02.01-4.52 3.43-3.67-2.14-21.48-7.58-8.46 1.91v.01h-.02v3.82h-14.98v.01h-.02v4.94l2.01 2.51V52.8l1.25 2.18-1.99-.49-4.63-2.1h-.02l-.8.17-.93.2-3.92-8.11.43-.96-1.11-.45-6.47-13.39z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2202",
    d: "m225.769 63.789-.87 1.68-2.18-.55z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2203",
    d: "M225.719 131.039v6.88l-3.46 2.41-4.89 3.4h-4.82l-2.58-3.2v-3.56h3.15l-.1-3.97 8.05 3.97.96-1.92h-.01l-2.73-1.1.82-3.69 4.56-.69z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2204",
    d: "M224.089 119.059h2.55l.44-.77 7.07 4.66.93 10.25h-.01l-7.56 1.57v-3.73h-1.79l-1.05-1.47-3.68-5.19 1.55-3.83 1.05-2.62h1.16z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2205",
    d: "m225.889 50.169-1.93-2.47 5.08-1.08.01.03-4.92 1.05 1.93 2.47-2.04.16-.02-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2206",
    d: "m223.809 20.069-.03.02-5.83-.22v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2207",
    d: "M223.429 48.349h.17l-1.09 1.13 1.49.84-.15.01-1.51-.85z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2208",
    d: "m223.589 117.929-1.05 2.62h-.01l-1.89.4.71-3.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2209",
    d: "M223.559 156.429v1.77l-1.53-.92v-1.37h1.53v.52z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2383",
    transform: "translate(222.029 155.879)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h1.53v.03H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2210",
    d: "m222.539 120.549-1.55 3.83 1.54-3.83z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2211",
    d: "m222.529 120.549-1.54 3.83-.87-1.24.52-2.19z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2212",
    d: "M220.109 160.169h-1.64l-1.56 1v1.86h2.01l1.19-1.24v-1.62zm4.63-1.17-8.29 9.6h-10.77l-3.28-8.99h5.66v-5.17l2.28 2.63 9.3-6.23h3.92v5.04h-1.53v1.43l1.53.92v-1.8l1.56-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2213",
    d: "m218.919 38.959 2.27.93h-.01l-2.28-.92z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2214",
    d: "m221.089 39.909-.01.01-.06-.03h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2215",
    d: "m221.079 39.919-3.71.81-.09-.01v-.01h.02l.07.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2216",
    d: "m221.079 39.919-3.71.8-.07-.01 3.05-.67.67-.15z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2217",
    d: "m221.019 39.889-.67.15.66-.15z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2218",
    d: "m221.009 39.889-.66.15-3.07.67-6.04-.96-.68-1.88 3.25-2.76 1.03-.87h2.89l2.37 3.85-1.25.81-.12.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2219",
    d: "m220.989 124.379 3.68 5.19-4.56.68v.01l-.83 3.69h.01l2.73 1.1-.95 1.92-8.05-3.97-2.5-1.24v-4.55h-.01v-.01h-2.82l-.57 2.01-2.81.09-.17-.56-.56-1.96h-.01l-4.46.03h-.01l-.85-1.13 3.78-1.72v-.01l3.97-6.59.63-4.91v-.01h.01l.33-2.6.33-.01 11.49-.32 4.2 1.53-1.64 6.89-1.24 5.2.01.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2220",
    d: "m220.349 40.039-3.05.67h-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2221",
    d: "m217.919 34.239 2.37 3.85-.17.1.15-.1-2.37-3.85z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2222",
    d: "M220.109 160.2v1.56l-1.19 1.24h-2.01v-1.8l1.56-1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2223",
    d: "M220.109 160.169v.03h-1.64l-1.56 1v-.03l1.56-1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2224",
    d: "m217.369 24.989-4.43-9.91 2.29-.12 11.48 3.67-2.9 1.44-5.86-.21v.01l-.17-.01 2.08 3.97.15-.06.03.06 6.03-2.47-3.12 8.49 6.47 13.39-8.22-3.35h-.01l-2.27-.93 1.2-.77.17-.1-2.37-3.85h-3.08l-.37-2.6-.41-2.96-.02.02v-.02l.65-.6h.01l2.6-3.01.06-.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2225",
    d: "m217.949 19.869 2.06 3.9-.15.06-2.08-3.97z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2226",
    d: "M219.639 150.8v.01l-9.3 6.23-2.28-2.63v-9.32h7.51L218 148.5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2227",
    d: "m221.179 39.889-.09.02-.06-.02-2.27-.93.09-.06 1.27-.81-2.37-3.85h.15l2.37 3.85-.15.1-1.2.77-.02.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2228",
    d: "m210.959 100.5 7.84 9h-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2229",
    d: "m210.959 100.5 7.82 9-11.48.33-.33.01h-.01l-.33 2.6h-3.96l-2.55-3.6.91-3.65v-.01l1.96-.92z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2230",
    d: "m218.729 38.969.12-.07-.09.06 2.27.93h-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2231",
    d: "m218.189 49.329.32-.98h.17l-.34 1.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2232",
    d: "m218.349 46.609-1.36 2.13-.02-.03V48.7l1.34-2.09-.79-1.51h.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2233",
    d: "m217.519 45.1.79 1.51-1.34 2.09-1.75-3.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2234",
    d: "M218.189 49.329v.01l-1.07-.45z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2235",
    d: "m218.129 49.389-1.08-.46 1.12.46.02-.05.11.05-.68 2.1-.16-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2236",
    d: "m218 148.5-2.43-3.41h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2237",
    d: "m217.749 34.239 2.37 3.85-1.27.81 1.25-.81-2.37-3.85z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2238",
    d: "m216.659 54.059 1.03 2.22h-2.44l-.03-1.75z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2239",
    d: "M217.689 45.1h-.17l-.01-.01h.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2240",
    d: "M217.519 45.1h-2.3v-.01h2.29z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2241",
    d: "m215.959 51.049 1.5.42-.01.02-1.58-.43z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2242",
    d: "m216.659 54.059-.02-.05h-.01l.82-2.5-1.61-.45h.03l1.58.43.01-.02.16.04-.82 2.5-.02.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2243",
    d: "m217.359 25-4.43-9.92h.01l4.43 9.91z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2244",
    d: "m217.3 25.069-2.6 3.01h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2245",
    d: "m211.239 39.749 6.04.96h-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2246",
    d: "M217.279 40.709v.01l-.07.01-5.96-.95 5.96.94.04-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2247",
    d: "m217.249 40.709-.04.01-5.96-.94-.01-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2248",
    d: "m212.769 15.089 4.43 9.9-.01.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2249",
    d: "m217.189 25-2.66 3.08h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2250",
    d: "M209.419 45.1v-1.55l2.2-2.74-.37-1.03 5.96.95.07-.01.09.01 3.71-.81 8.39 3.41.53 1.12-.96 2.16v.01l-5.08 1.08 1.93 2.47-1.89.15-1.49-.84 1.09-1.13h-5.09l-.32.98-1.07-.44-.04-.02 1.44-2.26-.8-1.51h-.03l-.01-.01h-7.43l-.01.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2251",
    d: "m218.479 46.609-1.43 2.24-.03-.04-.03-.06v-.01l1.36-2.13-.8-1.51h.14z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2252",
    d: "m218.519 46.609-1.44 2.26-.03-.01v-.01l1.43-2.24-.79-1.51h.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2253",
    d: "m217.049 48.929-.14-.06z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2254",
    d: "m217.019 48.809.03.04-.01.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2255",
    d: "m217.119 48.889 1.07.45-.02.05-1.12-.46-.14-.06.08-.12.03.06.02.05.01-.01v.01l.03.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2256",
    d: "m216.969 48.709.02.03v.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2257",
    d: "m216.989 48.749-.08.12-.03-.01v-.01l.09-.14z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2258",
    d: "m216.879 48.849-.01.01-1.79-3.7z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2259",
    d: "m216.809 54.009 1.05 2.27h-.17l-1.03-2.22.12-.04h.02v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2260",
    d: "M216.8 54.009v.01h-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2261",
    d: "m216.659 54.059-1.44.47v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2262",
    d: "m217.459 51.449-1.5-.42-.15.02-.02-.01-5.65.64-2.32-3.85 2.59-2.73h4.64l.03.06 1.79 3.7.01-.01v.01l.03.01.14.06 1.08.46z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2263",
    d: "m215.959 51.029 1.5.42v.02l-1.5-.42-.09.01-.06-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2264",
    d: "m215.839 51.059-5.69.65V51.7l5.43-.63.23-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2265",
    d: "m215.789 51.039.02.01-.23.02-5.44.62v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2266",
    d: "m215.579 145.089-.98-1.36h2.77l4.89-3.4 3.46 2.26v3.16l-2.16 5.05h-3.92L218 148.5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2267",
    d: "m214.6 143.729.98 1.36h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2268",
    d: "m215.579 51.069-5.43.63-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2269",
    d: "M215.249 56.279h-.01l-.02-1.75z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2270",
    d: "m215.219 54.529.02 1.75h-.16l-.03-1.69z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2271",
    d: "M215.219 54.519v.01l-.17.06v-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2384",
    transform: "translate(215.049 45.089)",
    style: {
      fill: "#038B9B"
    },
    d: "M0 0h.17v.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2272",
    d: "m216.639 54.009.02.05-1.44.46-.17.05v-.04l1.58-.51v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2273",
    d: "M215.049 45.1h.17l1.75 3.6v.01l-.09.14-1.8-3.69z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2274",
    d: "m215.049 54.519 1.58-.51v.01l-1.58.51z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2275",
    d: "m215.049 54.589.03 1.69h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2276",
    d: "M215.049 54.569v.02l-3.23 1.04v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2277",
    d: "M215.049 45.089v.01h-4.64l.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2278",
    d: "M215.049 54.529v.04l-3.23 1.05-.02-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2279",
    d: "M215.049 54.519v.01l-3.25 1.05v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2280",
    d: "m214.469 31.639.37 2.6h-.02l-.36-2.6z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2281",
    d: "m214.459 31.639.36 2.6h-.15l-.36-2.55z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2282",
    d: "M214.669 34.239h.17l-1.03.87-.1-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2283",
    d: "m212.929 15.079 4.43 9.92-.06.07-2.61 3.01h-.16l2.66-3.08.01-.01-4.43-9.9z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2284",
    d: "m214.309 31.689.36 2.55h-.02l-.35-2.55z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2285",
    d: "M208.059 154.439v5.14H202.4l-5.63-15.85h17.83l.97 1.36h-7.51v9.35z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2286",
    d: "m214.059 28.679.41 2.96h-.01l-.42-2.94z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2287",
    d: "m214.039 28.7.42 2.94-.15.05-.01-.01v-.04h.01l-.4-2.82z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2288",
    d: "m213.909 28.819.4 2.82h-.02l-.4-2.8z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2289",
    d: "m214.3 31.679.01.01h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2290",
    d: "M214.3 31.639v.04l-.01-.03v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2291",
    d: "M214.3 31.679v.01l-1.17.35-.05-.03 1.21-.36z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2292",
    d: "m214.3 31.689-1.17.36-.06-.03.01-.01.05.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2293",
    d: "M214.289 31.639v.01l-1.21.36z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2294",
    d: "m214.239 69.159-.64 14.47-.01.01-.2 4.6-8.62-5.53h-9.16l-2.35-11.28 3.62-3.88v-.01l3.88.93 1.81 2.2 4.57.91 2.08-3.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2295",
    d: "m214.689 28.079-.65.6v.02l-.13.12-.02-.14-.02.02v-.02l.65-.6h.17z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2296",
    d: "m213.889 28.679.02.14-.02.02-.02-.14z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2297",
    d: "m213.869 28.7.02.14-.6.56h-.16z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2298",
    d: "m213.809 35.109-3.25 2.76-.04-.1 3.13-2.66.05-.05h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2299",
    d: "m213.7 35.059-.05.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2300",
    d: "M213.169 93.2v.01l-2.21 2.18v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2301",
    d: "M213.069 32.009h.01l-.01.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2302",
    d: "m211.169 30.949 1.9 1.06h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2303",
    d: "m210.519 131.759 2.5 1.24.1 3.97h-3.15v3.56l2.58 3.2h-15.77l-.23-2.74 2.56-4.2v-9.98l4.46-.03.57 1.96.17.56v.01l2.81-.1h.01l.57-2h2.81v4.55z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2304",
    d: "m212.879 32-1.82-1.02.11-.03 1.89 1.06-.1.03h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2305",
    d: "M213.069 32.009v.01l-.11.03-.01-.01h.01l.1-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2306",
    d: "m212.879 32 .07.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2307",
    d: "m212.769 15.079 2.44-.13.02.01-2.29.12h-.01l-.16.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2308",
    d: "m211.059 30.979 1.82 1.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2385",
    transform: "translate(212.759 15.079)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2309",
    d: "M211.8 55.569v.01l-.15.05v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2310",
    d: "m210.459 57.569 1.32 2.88-1.18 1.87-.09-.12 1.1-1.75-1.32-2.88 2.62-1.29h.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2311",
    d: "m211.649 55.629-3.63 1.17 3.63-1.18z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2312",
    d: "m211.819 55.619-3.65 1.18-.15.05V56.8l3.63-1.17.15-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2313",
    d: "m211.649 55.619-3.63 1.18-.02-.15-.18-2.45v-.01l2.96-.58h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2314",
    d: "m211.819 55.629-3.65 1.17 3.65-1.18z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2315",
    d: "m211.029 39.749.38 1.06-2.17 2.72-5.12-.62-.22-.09h-.01l-3.7-1.46-.35-4.73h.35l3.8-.93.58.54.16-.01.01.01 2.57-.08 2.6.48.44 1.23z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2316",
    d: "m211.209 39.769.37 1.04-2.19 2.74-.12-.01 2.19-2.73-.38-1.06z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2317",
    d: "M209.419 43.549V45.1h-.04v-.65h.01v-.9l2.19-2.74-.37-1.04.04.01.37 1.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2318",
    d: "m211.139 29.439-1.33.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2319",
    d: "m211.009 30.949-.84.2-1.11-.85.32-.82.43-.01 1.33-.03 1.99-.04h.16l.6-.56.4 2.8-1.21.37h-.01l-1.9-1.06-.11.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2320",
    d: "m211.169 33.9 2.53 1.16-.05.05-2.64-1.21-3.509-.9v-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2321",
    d: "m210.939 53.579.86 1.99-.15.05-.86-2.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2322",
    d: "m211.8 55.569-.86-1.99h.01l-.03-.06-.77-1.81 5.69-.65 1.61.45-.82 2.5-1.58.51z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2323",
    d: "M210.959 100.489v.01l-7.97 3.76z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2324",
    d: "m210.919 53.519.03.06h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2325",
    d: "m210.149 51.709.77 1.81-.78-1.81z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2326",
    d: "m211.079 39.749-.68-1.88.09-.08.03.08.68 1.88.01.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2327",
    d: "m210.769 53.579.01.03-2.96.58-.02-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2328",
    d: "m210.729 53.469.05.11h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2329",
    d: "m210.559 37.869.68 1.88.01.03-.04-.01-.01-.02-.68-1.88-.03-.08.03-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2386",
    transform: "translate(210.509 127.209)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v4.55H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2330",
    d: "M210.459 15.209v1.57h-.17v-1.56z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2331",
    d: "M210.459 15.2v.01l-.17.01v-.02l2.47-.12v.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2332",
    d: "M210.459 16.779V15.2l2.3-.11h.01l4.42 9.91-2.67 3.08h-4.57l-3.12-1.58 2.67-6.05h-.88l-.03-.06-.73-1.77-.75-1.84h3.35z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2333",
    d: "m210.419 45.089-.01.01h-.17l.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2334",
    d: "m210.409 45.1-2.59 2.73h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2335",
    d: "m210.409 45.1-2.6 2.73-.14.03-.02-.03 2.59-2.73z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2336",
    d: "m210.289 15.219-3.42.17 3.42-.18z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2337",
    d: "m210.169 31.149.84-.2.05.03-.85.2z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2338",
    d: "m210.049 31.179.12-.03.04.03.25.18-.27 1.23-.15-.07.25-1.16z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2339",
    d: "m209.979 51.709.16-.02.01.01v.01h-.01l.78 1.81.02.06-.15.03h-.01l-.01-.03h.01l-.05-.11z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2340",
    d: "M210.079 36.629v.01l-.03-.01h.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2341",
    d: "m209.979 51.7.16-.02v.01l-.16.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2342",
    d: "m209.939 36.609.11.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2343",
    d: "m210.039 32.519-.02.07-2.53-1.15v-.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2344",
    d: "m210.079 36.639.41 1.15-.09.08-.45-1.24-.01-.02.11.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2345",
    d: "m209.979 51.709.75 1.76-.76-1.76z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2346",
    d: "M209.939 36.6v.01h-.05v-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2347",
    d: "m211.459 40.809-2.19 2.73-.03-.01 2.17-2.72-.38-1.06-.68-1.88-.44-1.23v-.01h-.01l-.01-.02h.05l.01.02.45 1.24.68 1.88z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2348",
    d: "M209.909 36.629v.01l-2.6-.48.03-.01 2.56.48z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2349",
    d: "m209.889 36.609-2.41-.45v-.01l2.41.44z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2350",
    d: "m206.829 26.5 3.12 1.58h-.17l-3.12-1.58 2.67-6.05h.17z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2351",
    d: "m207.469 34.789 2.05.69.55 1.15h-.02l-.11-.02V36.6l-.55-1.13-1.92-.64z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2352",
    d: "M209.389 43.549v.9h-.01l-.12.02v-.92l.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2353",
    d: "M209.379 44.449v.65h-.12v-.63z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2354",
    d: "M209.209 29.479h.17l-.32.82 1.11.85-.12.03-1.16-.88z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2355",
    d: "m207.479 36.149-.01-1.29 1.88.62.54 1.11z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2356",
    d: "M207.469 34.859v-.03l1.92.64.55 1.13-.05-.01-.54-1.11z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2357",
    d: "M209.259 44.469v.63h-.05v-.62z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2358",
    d: "M209.259 43.549v.92l-.05.01v-.03h.01v-.9l.02-.02.03.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2359",
    d: "m208.589 20.389.03.06h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2360",
    d: "m208.449 20.449-.76-1.83-.75-1.84h.16l.76 1.84.73 1.77.02.06z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2361",
    d: "m207.689 18.619.76 1.83h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2362",
    d: "m207.689 18.619.75 1.83h-1.09l-5.56 6.07 2.47 3.07-5.17 4.58-3.17-3.64 1.19-1.85v-5.6l8.59-6.3h1.23z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2363",
    d: "m207.969 56.869.05-.02v.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2364",
    d: "m207.969 56.869-.67.22z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2365",
    d: "m211.169 33.9-3.67-.94-.01-1.52 2.53 1.15.02-.07.15.07.27-1.23-.25-.18.85-.2 1.82 1.02.07.04.01.01.11-.03.06.03 1.17-.36.35 2.55h.02l-.96.82h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2366",
    d: "m207.109 16.779.75 1.84-.76-1.84z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2367",
    d: "M207.849 56.849v.01l-.14.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2368",
    d: "m207.829 56.649-.19-2.46h.01v.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2369",
    d: "m207.8 54.159.02.03h-.01l-.02-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2370",
    d: "m207.819 47.829 2.32 3.85-.16.02-2.31-3.84.14-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2371",
    d: "m207.819 54.2.18 2.45-.19-2.46h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2372",
    d: "m207.809 54.189.19 2.46.02.15-.17.05-.02-.2-.18-2.45v-.01l.14-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2373",
    d: "m206.989 53.039.8 1.12-.14.03-.78-1.08V53.1z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2374",
    d: "M207.509 34.789 207.5 33l3.51.9 2.64 1.21-3.13 2.66-.4-1.14-.56-1.16z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2375",
    d: "m207.969 56.869-.67.22-.69.22-.04-.04 1.14-.37.14-.04v-.01l.17-.05v.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2376",
    d: "m207.709 56.9-1.14.37-.18-.2-.76-3.3 1.24-.66.77 1.08.19 2.46.02.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2377",
    d: "m206.939 16.779.75 1.84-.76-1.84z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2378",
    d: "m206.869 53.109.78 1.08h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2379",
    d: "m207.649 47.829-.01.01-2.17.37z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2380",
    d: "M207.5 32.959V33l-.17-.04-.01-1.6.17.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2381",
    d: "m207.509 34.789 2.05.68.56 1.16.4 1.14-.03.02-.41-1.15v-.01h-.01l-.55-1.15-2.05-.69v.04l-.13-.04-.01-1.83.17.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2382",
    d: "m207.479 36.159 2.41.45.01.02-2.56-.48h.14z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2383",
    d: "m207.469 34.859.01 1.29h-.17l-.01-1.35.17.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2384",
    d: "M207.309 36.149h.03l-.03.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2385",
    d: "M207.309 36.149v.01l-2.57.08-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2386",
    d: "m206.989 53.039-.12.06-.05-.06-.61-.86.1-.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2387",
    d: "m206.969 109.839-.33 2.6h-.01l.33-2.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2388",
    d: "m205.509 53.739 1.31-.7.05.06v.01l-1.24.66z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2389",
    d: "m206.209 52.179.61.86-.62-.86z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2390",
    d: "m206.819 53.039-1.31.7-1.01-.25 1.7-1.31z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2391",
    d: "m206.629 112.449-.63 4.91-3.97 6.59-3.78 1.73-1.55-2.07v-3.53h3.96l-2.02-6.53h3.67l.38-1.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2392",
    d: "m207.809 58.7-1.21-1.39h.01l.69-.22.67-.22.05-.01v-.01l.15-.05 3.65-1.17 3.23-1.04.02 1.69h-2.16l-2.62 1.29 1.32 2.88-1.1 1.75-1.79-2.25 1.42-.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2393",
    d: "m206.6 57.309 1.21 1.39 2.33.65-1.42.6 1.79 2.25-.08.12-1.88-2.37 1.42-.6-2.33-.65-1.21-1.39h.01l.13-.04.04.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2394",
    d: "M206.309 52.089v.01l-.1.08h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2395",
    d: "m205.8 49.249.51 2.84-.11.08-.06-.07v-.01l-.5-2.82z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2396",
    d: "M206.2 52.169v.01l-.06-.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2397",
    d: "m206.139 52.1-1.76 1.35h-.02l1.78-1.36z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2398",
    d: "m205.639 49.269.5 2.82-.51-2.82z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2399",
    d: "m205.629 49.269.51 2.82-1.78 1.36-.81-.2-1.62-3.48z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2400",
    d: "m205.629 49.259.17-.02v.01l-.16.02h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2401",
    d: "m205.609 48.209 2.06-.35 2.31 3.84v.01h-.01l.76 1.76.04.11-2.97.58h-.01l-.8-1.12-.68-.94v-.01l-.51-2.84v-.01l-.19-1.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2402",
    d: "m205.629 49.239-.18-.99.16-.03.19 1.02-.17.02v-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2403",
    d: "M205.629 49.259v.01l-3.7.5v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2404",
    d: "m206.219 57.069-.76-3.3.05-.03.12.03.76 3.3.18.2-.13.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2405",
    d: "M205.609 48.209v.01l-.16.03v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2406",
    d: "m205.469 48.209 2.17-.37.01-.01.02.03-2.06.35-.16.03h-.01v-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2407",
    d: "m205.439 48.239.01.01-.1.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2408",
    d: "m204.669 48.349.77-.13v.02l-.09.02-.82.14-.04-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2409",
    d: "m204.729 36.229-.16.01-.58-.54.13-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2410",
    d: "m204.669 48.349-.18.04-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2411",
    d: "m204.489 53.479-.11-.03 1.76-1.35.06.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2412",
    d: "m204.529 48.4.82-.14-.82.15-.04-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2413",
    d: "m202.049 47.479 2.41.9-2.42-.89z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2414",
    d: "m204.459 48.379-.1.02-2.34-.87.02-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2415",
    d: "m204.329 53.489.05-.04.11.03 1.71-1.3-1.7 1.31 1.01.25-.05.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2416",
    d: "m204.259 29.589-2.47-3.07 5.56-6.07h.17l-5.56 6.07 2.47 3.07-5.27 4.66-.07-.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2417",
    d: "m204.359 48.409-2.35-.87.01-.01 2.34.87.1-.02v.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2418",
    d: "m204.139 128.739-.57-1.96h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2419",
    d: "m204.119 42.909 5.12.62-.02.02-5.27-.64h-.01l-.11-.05.06-.04h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2420",
    d: "m203.989 35.7-3.8.93h-.17l3.93-.96z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2421",
    d: "m202.009 44.029 1.81-1.16.12.04h.01l5.27.64v.9h-.01l-5.66 1.04h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2422",
    d: "m203.829 42.859.11.05-.12-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2423",
    d: "m203.829 42.859-.01.01-.09-.04h-.01l-3.63-1.44 3.64 1.43z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2424",
    d: "m203.729 42.819-3.64-1.43.1-.03 3.7 1.46-.06.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2425",
    d: "m203.719 42.829-1.86 1.19h-3.74l-1.24-1.63 3.21-1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2426",
    d: "M203.569 45.519h-.01v-.01l-.01-.02 5.66-1.04v.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2427",
    d: "m203.569 45.519 5.64-1.04v.62h1.03l-2.59 2.73-2.18.38h-.03v.01l-.77.13-.19.03h-.02l-2.41-.9-.6-.22 2.11-1.74z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2428",
    d: "m203.549 45.489.01.02-.02-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2429",
    d: "m202.009 44.029 1.53 1.46z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2430",
    d: "m203.359 53.2.19.05.81.2-.04.03-.94-.23z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2431",
    d: "m203.559 45.519-2.11 1.74h-.17l.01-.01h.16l1.56-1.28z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2432",
    d: "m203.009 45.969-1.56 1.28h-.16l1.56-1.28.55-.45.14-.03.02.02v.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2433",
    d: "m202.849 45.969-1.56 1.28 1.55-1.28z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2434",
    d: "m202.689 112.449-.38 1.1h-.01l.38-1.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2435",
    d: "m201.369 82.709 1.18 8.1-3 6.16h-13.31l-.41 2.01-.01.01-1.09.39-4.14-3.76 6.1-2.48v-4.48l8.77-5.95h5.91z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2436",
    d: "M202 44.019h-.14l1.86-1.19h.01l.09.04-1.81 1.16z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2437",
    d: "M202.029 123.949v.01l-3.78 1.72z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2438",
    d: "m202.019 47.529-.01.01-.14-.05.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2439",
    d: "M202 44.029h-.15l.01-.01h.14l.01.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2440",
    d: "M201.849 44.029h.16l1.53 1.46-.14.03-1.56-1.48z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2441",
    d: "m201.839 44.039 1.56 1.48z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2442",
    d: "m201.769 49.769 3.86-.52v.01l-3.7.5v.01l1.62 3.48-.19-.05-1.57-3.38z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2443",
    d: "m201.859 44.019-.01.01h-3.73v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2444",
    d: "m201.849 44.029-.01.01-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2445",
    d: "m201.829 44.029.01.01h-3.7l-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2446",
    d: "m205.629 49.249-3.86.52h-.01v-.01l3.87-.52z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2447",
    d: "m201.769 49.769.02.05-.03-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2448",
    d: "m201.879 47.479-.6-.22h.17l.6.22-.01.01-.02.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2449",
    d: "m202.989 104.259-1.96.92-1-2.95h2l-2.47-5.26 2.99-6.16-1.18-8.1h3.4l8.62 5.53-.22 4.96-2.21 2.18v5.11z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2450",
    d: "m201.029 105.189-.91 3.65-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2451",
    d: "M201.029 105.179v.01h-.01l-1-2.96h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2452",
    d: "M200.9 60.049v1.98l-.17-.03v-1.95z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2453",
    d: "m200.739 63.059-.01 1.82-.17-.04.01-1.78z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2454",
    d: "m196 107.239 3.56-7.36v-2.91l2.47 5.26h-2.01l1 2.96h.01l-.92 3.64.01.01 2.55 3.6h.01v.01l-.38 1.1h-8.55l.06-3.1h-1.34l.43-3.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2455",
    d: "m200.569 63.059-.01 1.78-1.91-.49.02-1.35z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2456",
    d: "m199.479 49.789 1.76-.92.77-1.33 2.35.87.1-.02h.03l.04.02.82-.15.1-.01.18.99-3.87.52v.01l.03.05 1.57 3.38-.41-.1-2.88-3.33-.16.01-.01-.01-.43.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2457",
    d: "m200.179 41.349-.1.03-.06-.02-.35-4.73h.16z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2458",
    d: "m200.089 41.389-3.21 1-.01-.02 3.21-.99z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2459",
    d: "m200.069 49.769 2.88 3.33.41.1.02.05-.6-.15-2.87-3.32z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2460",
    d: "m199.469 49.8.43-.03.01.01-.46.03.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2461",
    d: "m199.839 36.629.35 4.73-.1.03-.01-.01.1-.03-.35-4.72z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2462",
    d: "m199.659 36.629-2.17-.03 2.34.02v.01h-.16l.35 4.73-3.31 1.03h-.01v-.01l3.31-1.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2463",
    d: "m199.469 49.8.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2464",
    d: "m199.479 49.789-.01.01h-.01l-.18.01.01-.01 1.78-.93.8-1.38.14.05-.77 1.33z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2465",
    d: "m199.289 49.8-.01.01h-.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2466",
    d: "m201.069 48.869-1.78.93-.09.01h-.1l-.67-1.24-.69-1.31h3.54l.6.22-.01.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2467",
    d: "M199.109 49.809h.09l-.09.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2468",
    d: "m198.429 48.569.67 1.24h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2469",
    d: "m198.989 45.179.06.07h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2470",
    d: "m199.049 45.259-1.75.51 1.74-.52h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2471",
    d: "m198.139 44.039.85 1.14z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2472",
    d: "m198.879 45.259-.53.15.52-.16h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2473",
    d: "M197.609 60.049h3.12V62l-1.89-.29-1.23-.84z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2474",
    d: "m198.649 64.349 1.91.49v.04l-2.08-.53L198.5 63h.17z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2475",
    d: "M193.689 115.8h2.4v-2.25h2.55l2.02 6.53H196.7v3.53l-3.09-4.13z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2476",
    d: "m198.429 48.569-.71-1.31h.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2477",
    d: "m198.349 45.409-2.17.64z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2478",
    d: "m198.259 48.569-.69-1.28h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2479",
    d: "m196.879 42.389 1.24 1.63-1.25-1.63z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2480",
    d: "M198.119 44.029h.01l.01.01h-.18v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2481",
    d: "m196.179 46.049 2.17-.64.53-.15v-.01l-.91-1.21h.17l.85 1.14.05.07-1.74.52-.97.28-.32.1h-.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2482",
    d: "m197.969 44.039.91 1.21h-.01l-.91-1.21z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2483",
    d: "M197.959 44.029v.01l-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2484",
    d: "M197.949 44.019v.01l-1.19-1.57z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2485",
    d: "M197.739 47.259h-.05l.04-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2486",
    d: "m197.729 47.249-.04.01h-.13v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2487",
    d: "m198.939 49.819-.68-1.25-.68-1.28.11-.03h.03l.71 1.31.66 1.24z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2488",
    d: "m197.689 47.259-.11.03-.01-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2489",
    d: "m198.669 61.719-1.23-.85v-.82h.17v.82l1.23.84 1.89.29v.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2490",
    d: "M197.559 47.259h-.01l.02.03-3.08.71-.01-.03v-.01l3.08-.71z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2491",
    d: "M197.549 47.259h.02l.01.03h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2492",
    d: "m197.489 36.6-2.15-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2493",
    d: "m197.509 34.529-.51.76h-.16l.5-.75-.95-.94.12-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2494",
    d: "m197.3 45.769-.97.28z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2495",
    d: "m197.109 28.679-1.19 1.85-.09-.11.9-1.42.21-.32v-5.6l8.6-6.3h.16l-8.59 6.3z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2496",
    d: "m196.879 67.549-3.62 3.88 3.61-3.88z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2497",
    d: "m196.869 67.549-3.61 3.88-1.93-9.28 4.3.12-.17 4.94z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2498",
    d: "m196.869 42.369.01.02h-.01l1.25 1.63v.01h-.17v-.01l-1.19-1.56-.05-.07 3.31-1.03.06.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2499",
    d: "m196.839 35.289-.01.01h-.49z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2500",
    d: "m196.569 49.949 2.35-.14-.66-1.24.68 1.25-2.2.13 8.3 7.18-1.55.32-.39 2.07-1.25.73-.01-.08 1.09-.64.39-2.08 1.55-.31z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2501",
    d: "m196.729 29-.9 1.42h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2502",
    d: "m195.409 30.129-4.87.79-1.66-3.89 16.71-11.57 1.28-.07 3.42-.17v1.56h-4.75l-8.6 6.3v5.6l-.21.32-.91 1.42-.24-.29-.15.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2503",
    d: "m196.709 42.389.05.07-.06-.07z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2504",
    d: "m196.339 35.3-.99.01.28-1.4.76-.31.95.94-.5.75z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2505",
    d: "M193.749 113.549h2.34v2.25h-2.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "m197.559 47.249-3.08.71h-.01l-.6-1.8v-.01h2.14l.32-.1.97-.28 1.75-.51v-.01l-.06-.07-.85-1.14h3.7l1.56 1.48-.55.45h-.01l-1.55 1.28h-3.73z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "m195.919 30.529 3.17 3.64-.1.08-.5-.57-2.73-3.15.07-.11z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "m195.579 30.129.24.29-.07.11-.32-.38z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "m193.259 71.429 2.35 11.28h-.15l-8.77 5.95-17.53-12.93v-1.39l10.41-5.69v-4.07l6.73-2.57 5.03.14z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "m195.429 30.149-4.88.8-.01-.03 4.87-.79z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "m195.179 35.309.28-1.4.88-.36.05.05-.76.31-.28 1.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "m195.339 36.579-.56-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2513",
    d: "m194.609 36.569-.23-.9h.17l.23.9z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2514",
    d: "M194.489 48v.01l-.37.08z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2515",
    d: "m194.459 35.289.04.18.05.2h-.17l-.09-.38.58-3.25h.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2516",
    d: "M194.319 48.009V48l.16-.03.01.03-.37.09-1.34.31-.13-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2517",
    d: "m194.479 47.969-.16.03.15-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2518",
    d: "m193.139 36.529-.35-.86h1.59l.23.9h.17l.56.01 2.15.02 2.17.03.35 4.72-3.31 1.03v.01l.06.07 1.19 1.57.01.01.91 1.21-.52.16-2.17.64-.34.1H192.1l-.85.39.46-2.3.15-.7v-.01l-1.61-.84.05-.91.04-.76.15-2.9z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2519",
    d: "m192.789 35.669-.47-1.1 1.13-2.55 1.42.02-.58 3.25.09.38z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2520",
    d: "M194.319 48v.01l-1.67.38z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2521",
    d: "M194.019 53.089h.17l-.35 1.68-.16-.06z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2522",
    d: "m194.019 53.089-.34 1.62-.62-.23v-1.39z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2387",
    transform: "translate(193.699 46.149)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.17v.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2523",
    d: "m193.869 46.159.6 1.8-.15.04-.62-1.84z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2524",
    d: "m191.359 46.569.91-.41h1.43l.62 1.84-1.67.39-1.75-.14.33-1.62.09-.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2525",
    d: "m193.669 55.869-1.4-.4v-.06l1.57.46v2.92h-.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2526",
    d: "M193.669 55.869v2.92h-1.4v-3.32z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2527",
    d: "M192.889 54.479v-1.39h.17v1.39l.62.23-.01.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2528",
    d: "m192.319 34.569.47 1.1h-.17l-.47-1.1 1.13-2.55h.17z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2529",
    d: "m192.649 48.389-.04.01-1.72-.13z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2530",
    d: "m192.649 48.389-1.76-.12.01-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2531",
    d: "m190.889 48.269 1.72.13-1.72-.12z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2532",
    d: "M192.489 50.569h2.21l6.8 6.79.34 2.81-.16.09-.04-.3-.31-2.59-6.8-6.79h-2.2v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2533",
    d: "M192.329 50.569v.01h-.01l-.02-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2534",
    d: "M192.269 58.789h1.4v.01H192.1v-3.38l.17.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2535",
    d: "m192.269 46.159-.91.41.89-.41z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2536",
    d: "M192.159 53.119h-.17l.17-2.55h.14l.02.01h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2537",
    d: "M191.859 43.529v.01l-1.61-.84v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2538",
    d: "m191.239 46.539.47-2.3-.46 2.3z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2539",
    d: "m191.319 46.589.04-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2540",
    d: "m192.249 46.159-.89.41-.04.02-.09.04V46.6l.01-.04v-.01l.86-.39z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2541",
    d: "m191.249 46.539.85-.39h.17l-.02.01h-.15l-.86.39v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2542",
    d: "M191.239 46.549v.01h-.01l-.15.06z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2543",
    d: "m191.239 46.559-.01.04v-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2544",
    d: "M191.229 46.6v.03h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2545",
    d: "M191.059 46.609v.02h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2546",
    d: "m179.759 44.539 6.44-3.87 3.04 1.59h.01l.13.07.7.37 1.61.84-.63 3.07-.01.02h.01l-.01.02-.01.05-.32 1.56v.01l-.29 1.41-.01.03 1.88.86h-.14l-.17 2.55-5.96-.04h-.17l-1.23 1.6h-.01l-4.06-2.61-.38-5-2.82-1.52v-1l2.23-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2547",
    d: "m191.049 46.649-.01.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2548",
    d: "m190.9 48.249-.01.02v-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2549",
    d: "m191.039 46.7.01-.05.01-.02.02-.01.15-.06v.04l-.01.03h.01l-.33 1.62h-.01v.02l-.17-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2550",
    d: "m190.889 48.279-.01.03v-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2551",
    d: "m190.889 48.279 1.72.12.04-.01.13.01 1.34-.31.37-.08V48l3.08-.71.69 1.28.66 1.24-2.35.14 8.3 7.19-1.55.31-.39 2.08-1.09.64-.34-2.81-6.8-6.79h-2.21l-1.89-.87.02-.11.26-1.28z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2552",
    d: "M190.889 48.269v.01h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2553",
    d: "m190.889 48.269-.01.01-.16-.01v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2554",
    d: "m190.719 48.269-.29 1.41z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2555",
    d: "m190.589 49.709.03-.12-.02.11 1.89.87z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2556",
    d: "m190.489 38.119-.15 2.9-.16-.09.13-2.71z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2557",
    d: "m190.319 38.119 2.65-1.59-.35-.86h.17l.35.86-2.65 1.59-.18.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2558",
    d: "m190.879 48.309-.26 1.28-.03.12 1.9.86h-.16l-1.9-.87v-.02l.29-1.41.16.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2559",
    d: "m190.429 49.7 1.9.87h-.03l-1.88-.86.01-.03z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2560",
    d: "m187.839 39.7 2.47-1.48-.14 2.71z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2561",
    d: "m190.309 38.219-.13 2.71h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2562",
    d: "M190.289 41.789v-.01h.01l-.05.91z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2563",
    d: "M190.289 41.779v.01h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2564",
    d: "M190.279 41.789h.01l-.04.9-.16-.09.03-.72v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2565",
    d: "M190.249 42.689v.01l-.17-.09V42.6h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2566",
    d: "m191.689 43.529-1.61-.84v-.08l.17.09 1.61.84-.15.7-.47 2.3v.01l-.16.07-.02.01v-.02l.63-3.07z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2567",
    d: "m190.179 40.929.16.09-.04.76h-.01l-.01.01-.16.08.01-.09.04-.75v-.1z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2568",
    d: "m190.169 41.029-.04.75h-.01l-.24.13-.55.3h-.01l-3.02-1.59 1.46-.87z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2569",
    d: "m190.129 41.779-.01.09v-.09z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2570",
    d: "M190.119 41.779v.01l-.24.12z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2571",
    d: "m190.119 41.879-.03.72h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2572",
    d: "m190.079 42.689 1.61.84v.01l-1.61-.84z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2573",
    d: "M190.079 42.6v.01l-.67-.35.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2574",
    d: "M190.079 42.689v.01l-.7-.37z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2575",
    d: "m189.879 41.909.24-.12v.09l-.31.16-.39.21-.09-.04z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2576",
    d: "m189.809 42.039-.39.21z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2577",
    d: "m189.419 42.249.39-.21.31-.16-.04.72z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2578",
    d: "m189.419 42.249-.01.01-.09-.05h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2579",
    d: "m189.409 42.259.67.35v.08l-.7-.36-.13-.07.07-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2580",
    d: "m186.3 40.619 3.02 1.59-3.03-1.58z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2581",
    d: "m188.879 27.029 1.66 3.89-.16.03-1.67-3.92 16.71-11.57 1.45-.07-1.28.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2582",
    d: "M190.169 40.929v.1l-2.41-1.28.08-.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2583",
    d: "m187.839 39.7-.08.05-.09-.05 2.65-1.58-.01.1z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2584",
    d: "m186.289 40.629 3.03 1.58-.07.05h-.01l-3.04-1.59.09-.05h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2585",
    d: "m186.289 40.619-.09.05-.08-.04 1.55-.93.09.05-1.46.87z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2586",
    d: "m186.249 96.969-.42 2.01.41-2.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2587",
    d: "M186.249 96.969h13.3v2.91l-3.55 7.36-3.1.18-.44 3.03H188.6l-.54-2.42-3.98-.58 1.62-7.86.13-.6v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2588",
    d: "m186.2 40.669-6.44 3.87h-.17l6.53-3.91z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2589",
    d: "M186.109 57.1v1.61h-.17v-1.46z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2590",
    d: "m186.029 53.079-1.29 1.67-.11-.07 1.23-1.6z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2591",
    d: "M185.939 57.249v1.46h-1.68z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2592",
    d: "M184.259 58.709h1.68v.01h-1.85l1.85-1.61v.14z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2593",
    d: "m185.829 98.989-.13.6.12-.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2594",
    d: "M185.829 98.979v.01h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2595",
    d: "m185.819 98.989-1.08.4h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2596",
    d: "m182.119 100.349 2.61-.96h.01l1.08-.4-.12.6-1.62 7.86-.74.21z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2597",
    d: "m184.729 99.389-2.61.96-1.73.64h-3.75v1.9l-3.54-.7v-3.55l7.48-3.02h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2598",
    d: "m184.739 54.749.01.01-5.92 7.6-.16-.01 5.91-7.59-.01-.01.05-.07h.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2599",
    d: "m184.619 54.679-.05.07-4.18-2.67h.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2600",
    d: "m184.579 54.759-5.91 7.59-5.84-.44.89-7.43-2.88-.48.04-1.84 9.51-.07 4.18 2.66z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2601",
    d: "m184.569 54.749-4.18-2.66-9.51.07v-.01l9.51-.07z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2602",
    d: "m183.339 107.659-1.78.51-1.17-7.18 1.73-.64z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2603",
    d: "m184.239 38.469-2.24-.48-2.8-6.43h.17l2.8 6.43 2.24.47-.16 1.42h-.17z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2604",
    d: "m180.389 100.989 1.17 7.18-4.92 1.42v-8.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2605",
    d: "m182 37.989 2.24.48-.16 1.41h-.7l-.22 1.27-3.46.55-3.18.57 2.53-2.4-1.27-1.84 1.44-.79-.03-2.1-1.95-.18V31.5l1.96.06z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2606",
    d: "m179.869 41.689-3.39.62.04-.04 3.18-.57 3.46-.55.22-1.27h.17l-.22 1.26z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2607",
    d: "M179.569 64.579v4.07l-10.41 5.68v.62h-.73l-3.48.01h-.42l7.37-9.59 7.17-.75.5-.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2608",
    d: "M177.189 45.549v-1h.17v1l2.82 1.52.38 5 4.06 2.61-4.06-2.6h-.17l-.38-5z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2609",
    d: "m179.019 35.139-1.95-.18V31.5h.17v3.46l1.95.18.03 2.1-1.44.79 1.27 1.84-2.53 2.4-.21.04 2.57-2.43-1.27-1.85 1.44-.79z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2610",
    d: "M176.639 102.889v6.7l-7.24 2.1v-4.57l-.98-1.1 1.15-1V101.5l3.53.69z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2611",
    d: "M176.489 35.289v1.37l-1.06.37-.03-.04.92-.33v-1.37l-2.32-.16-.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2612",
    d: "M176.319 35.289v1.37l-.92.33-1.4-1.86z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2613",
    d: "M175.459 39.789v.02l-2.57-.35v-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2614",
    d: "M175.429 37.029v.01h-.01l-.04-.05h.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2615",
    d: "m174 35.129 1.4 1.86h-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2616",
    d: "m175.389 80.339 11.3 8.32v4.48l-13.59 5.5v3.55l-3.53-.7-.56-2.5v-.01h-2.87l-1.74-3.92v-1.64h7.68v-.01l-.04-.73-.69-12.34z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2617",
    d: "m174 35.129 1.38 1.86-.12.05-1.38-1.84.1-.07z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2618",
    d: "m175.429 37.039.2 2.77-.17-.02-.2-2.75.12-.05.04.05z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2619",
    d: "m173.879 35.2 1.38 1.84h-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2620",
    d: "m174.469 1.9-.01.01-11.74-1.191z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2621",
    d: "m174.459 1.909-1.59 1.6-4.52.93h-.01l-7.36 11.7-3.89 1.15h-.01l-5.58.34-2.75 2.12-7.37 2.18h-.01l-5.23 5.51h-3.41l-2.89-2.91-.13-5.2 4.59-2.62h.01v-3.83l-.01-.01-2.45-4.24h-.14l-9.45-.14v-1.91l5.72-1.76.57-.17 7.88-2.74h13.69L161.4.589h.01l1.31.13z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2622",
    d: "M174 35.129h-.02l.01-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2623",
    d: "m173.979 35.129-.1.07-.06-.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2624",
    d: "m173.549 54.479-.89 7.43h-.01l.89-7.42-2.71-.45v-.01z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2625",
    d: "M172.889 39.459v1.25h-.17v-1.27z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2626",
    d: "m169.159 75.739 6.22 4.59h-4.04l.7 12.35.04.73H164.4v1.65l-6.37-4.59.18-5.42h5.19l1.56-2.34v-4.83h4.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2627",
    d: "M172.889 39.429v.03l-.17-.02v1.27l-1.27.01v-3.74l2.43-1.78 1.37 1.84h.01l.2 2.75z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2628",
    d: "m173.539 54.489-.89 7.42-.59-.05-1.37-2.42.14-5.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2629",
    d: "M171.449 36.979v3.74h-.17v-3.74l2.54-1.86.06.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2630",
    d: "m173.709 54.489-.89 7.43-.16-.01.89-7.43-2.72-.45v-.02z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2631",
    d: "m172.829 61.909 5.84.44-.01.01-6-.44v-.01l.16.01.89-7.43-2.88-.48v.02l-.16-.03.04-1.84h.17l-.04 1.84 2.88.48z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2632",
    d: "m172.059 61.859.59.05v.01l-.76-.06-1.37-2.42.14-5.43.17.03-.14 5.4z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2633",
    d: "M169.159 75.739v2.14h-.01v-2.15h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2634",
    d: "m168.419 106.019.98 1.1v4.56l-4.94-5.33 2.32-2.18z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2635",
    d: "m166.779 104.169 1.64 1.85z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2636",
    d: "M166.779 104.159v.01l-2.32 2.18z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2637",
    d: "m166.779 104.159-2.32 2.19-2.36-2.54 2.3-2.31z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2638",
    d: "M164.959 77.879v4.83l-1.56 2.34 1.55-2.34v-4.83z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2639",
    d: "M169.159 74.959v.77h-.01v2.15h-4.2v4.83l-1.55 2.34h-5.18l.07-1.96 6.24-8.13h4.63z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2640",
    d: "m169.569 105.019-1.15 1-1.64-1.85v-.01l-2.38-2.66-2.3 2.31-2.46-2.66 2.07-2.16h7.3l.56 2.5v3.53z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2641",
    d: "m166.189 24.1-6.46-.92v-1.72l1.83.04.68-.93 3.22.07 2.68-.89 1.91 1.94v.53z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2642",
    d: "m161.709 98.989-2.07 2.16-1.92-2.07.01-.09z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2643",
    d: "m161.4.589-11.28 1.32h-13.69l-7.88 2.74 7.88-2.75h13.68z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2644",
    d: "m157.839 95.749 4.19 1.22H157.8z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2645",
    d: "m162.029 96.969-4.19-1.22.19-5.28 6.37 4.59 1.74 3.92v.01h-8.42l.08-2.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2646",
    d: "M134.309 12.879v3.83h-.01v-3.84z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2647",
    d: "m131.849 8.629 2.45 4.24-2.46-4.24z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2648",
    d: "m134.3 16.709-4.59 2.62.13 5.2-.01-.01-.13-5.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2649",
    d: "m129.839 24.529 2.89 2.91h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2650",
    d: "M122.259 6.579v1.91h-.02v-1.92l5.74-1.75z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2651",
    d: "M118.869 45.9h-8.05l.04-.04h7.97l-1.66-2.63h.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2652",
    d: "m117.149 43.189.02.03-1.48-.35v-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2388",
    transform: "translate(115.679 42.839)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v.03H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2653",
    d: "M115.679 40.959v1.88l-.04-.01V41z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2654",
    d: "m115.679 40.959-.04.04v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2655",
    d: "M118.829 45.859h-7.97l4.78-4.86v1.83l.04.01v.03h.01l1.48.35v.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2656",
    d: "m115.639 41-4.8 4.86h-.08l4.88-4.95V41z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2657",
    d: "m115.639 41-4.78 4.86h-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2658",
    d: "m112.049 166.519-2 3.48-5-1.84v-6.43z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2659",
    d: "m112.049 166.519-7-4.79v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2660",
    d: "M112.509 5.569 111.619 4l6.85-.14.93-1.23-6.61.13V1.709l19.58-1.46-4.93 2.79-6.51 1.3-8.08 3.77-.89-.76h-5.54l-.76-.75h5.07l-1.17-1.51z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2661",
    d: "m110.859 45.859-.04.04h-.02l.04-.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2662",
    d: "m108.229 108.629 1.1 2.4-.82 2.34-2.79.31.18-5.25z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2663",
    d: "m105.049 168.159 4.2 5.85-9.27 4.01.82 17.13-1.59-.17-4.37-6.69-.14-3.93-2.94-5.24-3.26-14.24 1.55-14.38h5.77l.39-.71 6.9 4.68v3.01h3.4l2.51-1.52.11 1.56-4.09 4.2h.01v6.44z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2664",
    d: "m107.7 2.4 1.51 1.13-2.09 1.34-3.65-.69z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2665",
    d: "m109.139 157.519-4.09 4.2h-.01l4.09-4.2-.11-1.56v-.01h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2666",
    d: "m108.849 153.559.17 2.39-2.51 1.53h-3.39v-3.01h-.01l-6.9-4.68H96.2l1.85-3.4 4.35-.03.12 3.83z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2667",
    d: "m108.509 113.369-2.79.32v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2668",
    d: "m107.8 199.339-5.77-.21-1.87-1.72 1.42-1.32z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2669",
    d: "m105.9 108.429-.18 5.25-2.04.23-1.7.18-1.42-3.64 1.28-2.37v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2670",
    d: "M105.719 113.679v.01l-2.04.22z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2671",
    d: "M104.429 8.349h7.19l-2.47 1.73-9.45-.74 2.33-1.99z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2389",
    transform: "translate(103.109 154.469)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v3.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2672",
    d: "m106.759 14.609-7.6.41-2.06.11 3.98-4.22 1.65.01-1.14 2.82 3.41-2.8 1.46.02 9.81 4.01.08 2.81 1.77.64.99 1.86-1.76 1.17-3.06-1.09v3.98l-.87.37-2.66-1.26.92 2.03-1.06.46-3.87-3.2h-4.56v-1.29h4.5l2-1.63 3.96.06z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2673",
    d: "m102.3 143.109.1 3.25-4.34.02-.01.01-1.85 3.4-.39.71h-5.77l-3.2-6.44v-9.71l4.25-1.2 3.81 3.91z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2674",
    d: "m101.979 114.1-4.16.47.24-4.96-.23 4.95z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2675",
    d: "M98.069 109.369v-.01l-1.8.67 1.24-6.07 4.33 4.12-1.28 2.37 1.42 3.64v.01l-4.15.46.23-4.95z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2676",
    d: "M99.609 47.119v.01h-.07l.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2677",
    d: "m99.609 47.129-.22.67-.66 2.08-.06.01.87-2.76z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2678",
    d: "m98.729 49.879.66-2.08-.65 2.08z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2679",
    d: "M98.069 109.359v.01l-1.8.66z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2680",
    d: "m98.059 11.6-4.38 1.16-.41-1.43 3.9-.9z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2681",
    d: "m98.059 22.739-.53 1.29-4.98-.53 2.52-2.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2682",
    d: "m97.489 103.939.02.02-1.24 6.07h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2683",
    d: "m97.489 103.939-1.23 6.09-4.17 1.53.26 3.37-3.1 1-.97-2.17h-.01l-.76.05v-6.39H87.5l-4.78-.49-2.08-2.3-.38-4.48-.03-.37 7.2.06 3.1 2.21 5.58.55 1.4 1.34v.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2684",
    d: "m96.259 110.029-4.15 1.53.25 3.37h-.01l-.26-3.37z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2685",
    d: "M43.719 15.849v-.01l19.61-.41 10.29 4.11 4.23-1.98 8.01 1.5 4.6-2.19-.9-1.85L93 13.5l.47 2.9 1.98.2-.48 2.4 4.25-2.81 3.08.35-3.29 3.42-8.08.89 1.1 1.62-5.25.96-9.25 6.85 9.25 5.02-.05 5.14h2.6l10.74-15.64h3.98l2.92 2.49-.04 3.57 6.06-2.39.57 7.58 4.63.8-.03 1.54-6.36 3.39-8.47.36-5.28 2.54v1.44l5.52-2.5.86.82-1.76 2.73 1.78 1.6 3.81.18-7.81 2.74-.27-1.19 2.87-1.37-4.31.75.65-2.08.22-.67v-.01h-.06l.01-.04H97.1l-2.74 2.37h-6.35l-1.96 1.35h-2.83l-.87-2.62-2.23.16-1.33-.98-.82-2.91-6.57 1.39-3.88-1.77H34.509v-1.44l-2.95-2.67 1.65-7.52.02-.03.02.02 1.62-1.74-1.42-1.47h-1.6l-1.56-1.78 13.42-11.59z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2686",
    d: "m90.839 89.119-.52.85H88.9l.52-.85z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2687",
    d: "m87.459 178.239-1.33-32.54.71-1.64 3.2 6.44v.01l-1.55 14.37 3.26 14.25 2.94 5.23.14 3.93 4.37 6.7-1.97-.2-6.09-7.88-.17-5.83z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2688",
    d: "m87.139 12.229 5.55-1.81-.84 2.25-3.21 1.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2689",
    d: "m88.629 16.249-2.35 1.2-.92-1.2 2.57-1.11z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2690",
    d: "m88.269 113.759.97 2.17h.01l3.1-1h.01l-.25-3.37 4.15-1.53h.01l1.8-.66-.01.24-.24 4.96 4.16-.47 1.7-.19 2.04-.22 2.79-.32.82-2.34 1.92 4.18-2.17 3.2 2.98-2.3 2.1.91-1.03 2.77 3.17-1.85 3.16 1.37-.18 1.87 6.85.42 7 4.55v3.38l-4.28 5.6-1.84 13.71-9.92 4.39-.96 6.17-4.08 7.12-7-4.8 4.09-4.2-.11-1.57h-.01l-.17-2.39-6.33-3.37-.12-3.83-.1-3.25-7.4-6.05-3.81-3.91-4.25 1.2-1.39.39-6.26-5.39 1.65-5.38 3.74-.46v-1.46h.01v-8.04l2.91-.2h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2691",
    d: "m87.5 87.949-.01.01-4.13-.46v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2692",
    d: "m84.739 88.749-1.38 1.03V87.5l4.13.46-.54.79z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2693",
    d: "M84.589 114.009v8.04h-.01v-8.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2694",
    d: "M83.359 87.489v.01h-2.58l-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2695",
    d: "m81.619 88.689-.84-1.19h2.58v1.72h-3.25v-.53h1.51z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2696",
    d: "m82.339 53.419-2.13 1.47h-2.59l.01-.01H80.2z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2697",
    d: "m80.779 87.5.84 1.19h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2698",
    d: "m73.809 112.629.6-3.89-.19-.63-.43-1.46.81-1.16-.38-1.4-.03-.1 1.52-.1 3.05-4.13 1.47.01v.01l.03.37.37 4.48 2.08 2.3h.01l4.78.49v6.39l-2.91.19v.01h-.01v8.03l-7.04-4.02-5.13-2.93-.37-.21h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2699",
    d: "m77.539 118.019-.01.01-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2700",
    d: "M77.539 118.019h-.02l-5.11-2.93z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2701",
    d: "m77.519 118.019.01.01-5.39 6.61h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2702",
    d: "m72.409 115.089 5.11 2.93-5.39 6.62-3.01-1.45.31-5.02 2.61-3.29z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2703",
    d: "m77.149 12.529 2.42-.94.55 1.78 1.37-1.78h2.28l-2.28 2.95 2.96 1.36-3.03.7-4.04-.96-3.63 1.58-5.28-2.05 4.25-1.09L70 12.939l4.62-1.57z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2704",
    d: "M82.339 53.419h-2.59l-2.14 1.46h.02l-.01.01h2.59zm-9.81-5.89 1.6-.77 1.19.72.08.05 2.7.1.23.76-4.09.88-.1.17-3.37 5.44v.01h1.8v-.01l3.07-4.51 1.65-1.1H78.7l-.37 3.14v.01l1.3-.14.53-.05 1.79-1.39h4.15l-2.1 1.44h1.5l2.11-1.44H86.1l1.96-1.35h6.35l2.73-2.36h2.4l-.87 2.76.06-.01-.02.06-1.56.27h-.01l-23.09 19.75h-.01l-.06 8.88-2.26-.06-.94-7.13v-.01l-14.27-.04h-.01l-5.99 7.53h-.01l-3.21-6.32h-.01V72.8l-3.89.14-1.12-1.69-.73-1.11h-.01v-.01l-13.88-1.79v.01l-3.97-3.96v-8.82l10.87-11.46h33l3.84 1.75.03.02-.76 1.65z",
    style: {
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2705",
    d: "m74.7 90.569-.88-.75v-1.03h2.53l.89.89v.89z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2706",
    d: "m74.5 105.159.1.33-.08-.25z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2707",
    d: "m74.6 105.489-.81 1.16-.01-.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2708",
    d: "m74.189 104.109.31 1.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2709",
    d: "m73.789 106.649.43 1.46-.44-1.47v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2710",
    d: "m74.219 104.089.38 1.4-.1-.33-.29-1.08-.02-.09z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2711",
    d: "m74.209 104.079.29 1.08-.31-1.05-.03-.12h.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2712",
    d: "m74.159 103.989.03.12-.04-.12z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2713",
    d: "m74.139 49.439-3.36 5.44h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2714",
    d: "M73.779 106.619v.01l-.01.01-.61-2.01h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2715",
    d: "m73.509 10.829-8.57 2.92-1.5-1.77 8.1-2.06z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2716",
    d: "m78.189 140.379-9.18-15.64.1-1.55h.01l3.01 1.45h.01l5.39-6.61 7.05 4.02v1.46l-3.74.46-1.66 5.39 6.26 5.39 1.4-.39v9.7l-.71 1.64z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2717",
    d: "m71.429 45.879-.77 1.65.76-1.65z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2718",
    d: "m71.389 45.859.03.02z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2719",
    d: "M70.779 71.639v.01l-14.27-.05z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2720",
    d: "m70.459 102.7 3.29-.29v.01l-3.28.29-1.17.97-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2721",
    d: "M69.359 82.149h3.72l7.03 5.07h-5.88l1.3-1.44-3.4-2.26h-4.21z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2722",
    d: "m71.059 104.419-.89 1.32-3.65-1.3v-.01l1.24-1.6 1.53.84.01.01 1.17-.97 3.28-.29.43 1.57h-.03l.04.12.31 1.05.02.08.07.24-.81 1.14-.61-1.99h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2723",
    d: "m67.749 102.819.01.01-1.24 1.6 1.14-1.49z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2724",
    d: "m67.659 102.939-1.14 1.49h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2725",
    d: "m66.889 102.339.86.48-.09.12-1.15 1.49v.01l-.88-.31-.01-.01-2.45-3.32 3.68.39.03 1.15z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2726",
    d: "m66.679 93.139.18 8.04-3.69-.39-2.16-2.9.73-.62z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2727",
    d: "M63.159 100.8h.01l2.45 3.32z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2728",
    d: "M62.519 88.169v.01l-.01.01-2.66 1.98h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2729",
    d: "m62.509 88.189-.05.1-.01.01L59.9 90.2h-.04l-.01-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2730",
    d: "m62.449 88.3-2.15 4.06-.44-2.16h.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2731",
    d: "m61.739 97.269-.73.62v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2732",
    d: "m60.809 96.149-.41 1.46-.01-.01.41-1.45z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2733",
    d: "m58 96.529.72-1.3 1.44.64.64.28-.41 1.45z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2734",
    d: "m61.739 97.269-.73.61-.61-.27.41-1.46H60.8l-.64-.28-1.44-.65.05-.08.05-.09 1.03-1.84 6.83-.07z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2735",
    d: "m60.3 92.359-.01.01-.44-2.17h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2736",
    d: "m60.159 95.869-1.44-.64v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2737",
    d: "m59.849 93.209-1.03 1.84.32-.59z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2738",
    d: "m59.849 90.169.01.03h-.01l-.01-.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2390",
    transform: "translate(57.789 90.159)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h2.05v.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2739",
    d: "m58.769 95.139-.05.08v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2740",
    d: "m58.719 95.209-.73 1.31-3.34-1.68 1.13-2.01h2.4l-.34-2.63h2.01l.44 2.17z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2741",
    d: "m57.829 90.469.31 2.32h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2742",
    d: "m58.719 95.229-.72 1.3-.01-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2743",
    d: "m57.839 90.2.34 2.63h-2.4l-1.13 2.01-.02-.01-.02-.02 1.13-2.02h2.4l-.31-2.32-.03-.26-.01-.04h2.05l.01.03z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2744",
    d: "m57.789 90.169.01.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2745",
    d: "m57.429 89.069-6.39.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2746",
    d: "m55.739 92.789-1.13 2.02-.01-.01 1.13-2.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2747",
    d: "m54.609 94.809.02.02-.03-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2391",
    transform: "rotate(-45 141.753 -18.466)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.014v.014H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2748",
    d: "m47.289 72.809 3.21 6.32-3.22-6.32z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2749",
    d: "M47.279 72.8v.01h-.13l-3.76.13z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2750",
    d: "m47.149 72.809-3.77.14v-.01h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2751",
    d: "M31.849 29.219h1.6l1.42 1.47-1.62 1.74-.02-.02 1.6-1.72-1.42-1.46h-1.6l-1.56-1.79 13.43-11.6h.03v.01l-13.42 11.59z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2752",
    d: "m42.269 71.249 1.12 1.69h-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2753",
    d: "m42.269 71.249 1.11 1.69-1.85-2.8z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2754",
    d: "m42.269 71.249-.74-1.11h.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2755",
    d: "M41.529 70.129v.01l-13.88-1.8z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2756",
    d: "m41.529 70.139-13.87-1.79h-.01v-.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2757",
    d: "m30.859 41.2 2.23 1.83v1.03h-1.63l-1.56-2.04z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2758",
    d: "M31.809 29.229h1.6l1.42 1.46-1.6 1.72-4.28-4.27-14.12.49-12.24 5.85-2.34-.19 6.41-4.19h-.03l.02-.01-3.33.06 3.89-5.26 8.03-3.01H15.2l.03-.01L9 22.1l1.4-1.96 7.39.09h.01v-2.92l6.57-2.65 16.26-.09 3.05 1.27-13.43 11.6z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2759",
    d: "M32.909 70.129h-1.99v4.04l3.37 7.18-1.75 1.35-4.27-8.08-.59-6.25-.02-.02 13.87 1.79 1.85 2.8v.01l3.77-.14h.13l3.22 6.32-2.58 3.24.01.01 3.11 6.69v.01l6.39-.01 2.32-3.82 2.93.06-.11 2.9-.11.08.05-.1.01-.01v-.01l-2.68 1.99h-2.05v.01l.01.04.03.26.3 2.32h-2.4L54.6 94.8l-2.24-2.28-2.6.69-10.4-4.34-6.38-14.98z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2392",
    transform: "translate(17.789 17.309)",
    style: {
      fill: "#e7e8e9"
    },
    d: "M0 0h.01v2.92H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2760",
    d: "m15.239 21.879-8.03 3.01 7.99-3.01z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2761",
    d: "M10.4 20.139 9 22.1h-.01l1.4-1.96z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2762",
    d: "m7.209 24.889-3.89 5.26h-.01l3.89-5.26z",
    style: {
      fill: "#e7e8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2763",
    d: "m6.659 30.1-6.41 4.19 6.38-4.19z",
    style: {
      fill: "#e7e8e9"
    }
  }))))))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2764",
    d: "m216.909 161.2 1.56-1h1.64",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2765",
    d: "M220.109 161.759v.03l-1.19 1.24h-2.01V163",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2766",
    d: "M208.059 159.579v.03H202.4l3.28 8.99h10.77l8.29-9.6.38-2.59-1.56.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2767",
    d: "M223.559 150.839h-3.92l-9.3 6.23-2.28-2.63",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 33",
    transform: "translate(222.029 155.909)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h1.53"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2768",
    d: "M223.559 158.2v.03l-1.53-.92v-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2769",
    d: "m82.339 53.419-2.14 1.46h-2.59l2.14-1.46",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2770",
    d: "M99.609 47.129h-2.47",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2771",
    d: "m98.709 49.939.02-.06.66-2.08",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2772",
    d: "m73.979 78.839.06-8.88h.01l23.09-19.75",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2773",
    d: "M50.509 79.129 56.5 71.6h.01l14.27.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 34",
    transform: "translate(47.279 72.809)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 3.22 6.32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2774",
    d: "m41.529 70.139 1.85 2.8v.01l3.77-.14",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2775",
    d: "m70.659 47.529.77-1.65h-.01l-.03-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2776",
    d: "m75.319 47.479-1.19-.72-1.6.77",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 35",
    transform: "translate(75.399 47.529)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.7.1 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 36",
    transform: "translate(70.779 49.439)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 5.44 3.36 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2777",
    d: "M78.7 49.269h-1.41l-1.65 1.1-3.07 4.51v.01h-1.8v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2778",
    d: "m79.629 52.279-1.3.14v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2779",
    d: "m115.639 41-4.8 4.86-.04.04h.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2780",
    d: "M115.679 40.949v.01l-.04.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2781",
    d: "M115.689 42.869h-.01v-1.91",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2782",
    d: "m118.869 45.9-1.68-2.67h-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 37",
    transform: "translate(51.039 89.069)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M6.39 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2783",
    d: "M41.529 70.139v-.01l-13.88-1.79",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2784",
    d: "M47.279 72.809V72.8l-3.89.14h-.01l-1.11-1.69",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2785",
    d: "m47.929 82.379-.01-.01 2.58-3.24",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2786",
    d: "m166.189 24.1 3.86-1.88v-.53l-1.91-1.94-2.68.89-3.22-.07-.68.93-1.83-.04v1.72z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2787",
    d: "M198.669 63h-.17l-.02 1.35 2.08.53v-.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2788",
    d: "M161.4.589 150.109 1.9h-13.68l-7.88 2.75",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2789",
    d: "m172.869 3.509 1.59-1.6.01-.01-11.75-1.18",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2790",
    d: "m160.979 16.139 7.36-11.7h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2791",
    d: "m148.749 19.749 2.75-2.12 5.58-.34",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2792",
    d: "m131.839 8.629 2.46 4.24v3.84l-4.6 2.61.13 5.2.01.01 2.88 2.91h3.42l5.23-5.51h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2793",
    d: "m127.979 4.819-5.74 1.75v1.92h.02l9.45.14",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2794",
    d: "m344.739 80.609-1.12-1.17-1.83 2.6 1.83 1.71z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2795",
    d: "m287.769 44.879 14.76 8.62 17.08.19 2.05-4.19 5.52-1.15",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2796",
    d: "M322.249 43.279h-7.31l-14.93-3.7-.01.01-1.63 3.69h-.01l-6.06-1.85-.02.01-4.51 3.44",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2797",
    d: "M327.549 46.3v-.01l-3.84-.61",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2798",
    d: "m330.419 87.449-2.19.49v1.29l.89 1.08 1.3-1.62z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2799",
    d: "M345.439 53.5v-7.21l-8.94-2.28-6.58-6.44h-6.38v.01l1.45 5.15h-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2800",
    d: "m326.479 85.389.01.01 1.8-1.02.06 1.74 10.62-3.79 3.47-7.77-6.19-10.19 3.18-3.47h-3.66l-1.17.76-2.3-3.77 2.92-2.56 2.01 3.83 2.81-1.93 2.13-1.47",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2801",
    d: "m313.019 76.289-.96 2.6 3.7 6.16",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 38",
    transform: "translate(306.029 73.279)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 4.84 2.09"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2802",
    d: "M299.589 75.2h.01l3.15 1.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2803",
    d: "m284.669 64.649.27 5.48h.01l2.41.84h.01l11.4 3.94",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2804",
    d: "M276.049 57.069h-.01l.57 1.39 1.26 3.09h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2805",
    d: "m281.379 49.749-.01.01 1.07 4.93",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2806",
    d: "m322.249 43.289 1.46 2.39 3.84.62-.37 2.05-5.51 1.16-2.06 4.18-17.08-.18-14.77-8.62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2807",
    d: "m359.149 54.129 2.5-.03 1.06-1.82-5.55-2.33.11 4.59 1.1.65z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2808",
    d: "m352.249 64.739-.41 1.41 5.5-.81.43 2.12 1.25-.53.13-1.68 3.69-.94-.2-4.83-1.67-2.92-1.67-.49.95 4.39-3.4 3.09z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2809",
    d: "m351.279 67.459 1.99-.25.65.96-.72 2.26z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2810",
    d: "m356.589 66.529-.96 1.74-1.27-1.44z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2811",
    d: "m350.569 96.329-3.02-.32-1.1-1.37 1.1-2.52-1.09-2.41-1.99-.04-.49 4.25 2.82 3.39 3.3.42z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2812",
    d: "m341.059 103.869 1.33.26 2.38-1.97-.05-1.62z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2813",
    d: "M351.479 106.919v1.9l1.98-.6-.67-1.22 1.6-.41-1.36-4.24-1 2.62h-3.29z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2814",
    d: "m345.629 97.449 1.41 1.39-.46.85-1.14-1.11z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2815",
    d: "m347.039 100.849 1 .68 1.1-1.66-1.46-.18z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2816",
    d: "m350.779 99.109 1.38 1.78h1.51l-1.44-2.31z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2817",
    d: "m350.779 100.609.78 1.36-.62.82-1.09-1.64z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2818",
    d: "m349.139 101.979.71 1.07-.71.85-.8-.99z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2819",
    d: "m352.749 131.119 2.6-.31v-.97h-3.53v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    transform: "translate(340.699 110.349)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.37 0 0 .25"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2820",
    d: "m330.949 114.829-.04.01.13 3.68 2.09 3.66h6.65l3.29-4.2v-7.62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2821",
    d: "M326.179 124.439v-2.81l-10.96-11.38-3.75-1.43 12.7 17.29z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2822",
    d: "m338.989 129.439.2.95-13.7-2.32 2.06-1.65 3.42 1.3 3.08-.68z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2823",
    d: "M347.749 129.439h-2.12l.41 1.37h2.02l.85-.69z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2824",
    d: "m344.049 131.659.62.76h1.47l-.51-1.1z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2825",
    d: "m351.819 129.849-2.12 2.36 1.61.2 1.44-1.29z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2826",
    d: "m344.769 125.669 1.58-.48-.48-2.78.93-1.03.78 2.06 1.89.66v-1.48l-1.07-2.35 2.02-1.69-3.22.13-.66-.91 1.28-1.4 2.36.81 1.17-.1 1.74-2.06-1.53-.03-1 .65-3.29-.8-2.18 1.97.15 3.11-1.26 1.69z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2827",
    d: "m356.589 121.249-.37 1.29 3.56-.37v-.92z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2828",
    d: "m357.409 112.959-1.19 1.18-.45 2.92 1.64.4-.37-2.59.96-1.19z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2829",
    d: "m365.479 120.739-.47-2.53-3.9.55z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2830",
    d: "M374.489 121.459v-.01l-3.79-1.97-3.53 2.87-3.73-1.47-.42 2.05 2.2-.08 5.44 2.27.98 2.79-1.81 1.1 4.66 1.62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2831",
    d: "m343.709 60.809 2.19 4.75 2.66-.19.45-3.06-3.68-3",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2832",
    d: "m345.329 59.309-1.62-1.33 2.1-.28-.37-4.19V53.5l-.01.01-3.26 2.25-2.13 1.46v.01l1.58 2.99 2.09.59z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2833",
    d: "M343.069 110.349v-2.78l-2.44.2-2.92 3.94-6.76 3.12 1.39.84 6.44-1.44 1.92-3.63 2.37-.24z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2834",
    d: "m318.249 107.769 1.17 3.81 4.83 4.12.38-1.47-4.56-6.73h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2835",
    d: "m374.489 130.629 1.7.6 3.24-2.98 4.2 4.1 3.83.78-4.75-4.74.23-2.51-8.45-4.42z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2836",
    d: "m385.089 126.309 1.7 1.02 2.96-1.66v-1.72z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2837",
    d: "m387.469 121.489 3.44 2.47 1.38-.47-3.5-2.09z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2838",
    d: "M315.769 86.5v-1.45l-3.7-6.16.95-2.6-2.14-.92h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    transform: "translate(313.669 86.499)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.53 2.09 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2839",
    d: "m306.649 86.779 2.14 1.79.81 4.27 1.51.45 1.08-1.35 2.01 2.26 1.11 4.13-.26 4.25v.02l1.72-3.38",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2840",
    d: "m308.009 77.429-.01.01-1.04 7.21v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2841",
    d: "M317.579 87.559v2.75h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2842",
    d: "m317.629 84.109-1.86.94h-.01V86.5",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2843",
    d: "m322.279 89.309-.01-.01-1.12-3.47",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    transform: "translate(322.959 90.029)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.53 2.69 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2844",
    d: "m322.139 96.019 2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06h-.01l-2.09 1.52v.01l3.1 11.19-1.72 3.36-.01.02-.1 1.68 3.01 2.56.29.93h.01l1.81-.27-2.92-4.31.68-6.67 3.29 3.26",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2845",
    d: "M327.339 96.019h-5.2l-1.03 1.03v2.73l1.64 1.63 1.85-.26",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2846",
    d: "M326.489 85.389h-.01l-4.23-3.62-4.62 2.34 3.52 1.72 1.13 3.47v.01l.68.72 2.53 2.69 1.85 1.97V99.1l-2.74 2.05.07 2.95 5.25-3.47-.18-5.16-5.48-5.8.27-3.17 1.95-1.11",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2847",
    d: "m300.839 83.829 1.07-1.03 4.74 3.98.31-2.12-2.49-2.34",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 42",
    transform: "translate(299.189 78.069)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.17 0 0 .55"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2848",
    d: "m272.549 81.789.27.32 2.71.86-1.27 1.3 1.2 1.56 2.16.25L278 84.3l.85.01 6.91 19.88 4.39-2.7.68-7.99 10.01-9.67-1.65-5.21v-.01l1.17-.54 1.71 2.28 1.99-.82.41 2.79 2.49 2.33 1.05-7.22 2.86-2.06.01-.01-4.84-2.09-.01.01-3.27 3",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 43",
    transform: "translate(272.539 80.909)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M3.28 0 0 .87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2849",
    d: "m280.239 71.9-3.8 3.5H274v2.59l1.82.69",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2850",
    d: "m277.649 67.489 1.75.99v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2851",
    d: "m287.339 74.049.02-3.08v-.01l-2.41-.83-.28-5.48",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2852",
    d: "M299.2 77h-.01l.4-1.8-.82-.29",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2853",
    d: "m298.769 74.909-11.4-3.95v.01l-.03 3.08 9.67 3.66z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2854",
    d: "m299.6 75.2-.4 1.8 1.34.33 1.53.38.68-1.42.01-.01z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2855",
    d: "M254.149 37.069v3.82h-15v4.94l2.01 2.51 4.3-1.73 2.56 1.73-3.11 1.51-.09 2.24 2.05 1.7 2.61-.72 2.31 1.93",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2856",
    d: "m287.759 44.869-3.67-2.14-21.48-7.58-8.46 1.91",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    transform: "translate(287.759 44.879)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2857",
    d: "m282.439 54.689-1.06-4.94 6.38-4.86v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2858",
    d: "m251.389 49.989 3.56-.83 4.24 2.91.46.31 3.93-.75 2.88 3.79 2.77-.12 2.71-2.23 6.4-.28.01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2859",
    d: "m260.159 66.229-.01-.01 1.1-2.32",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2860",
    d: "m264.809 76.569-1.92-2.4-.32-.93",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2861",
    d: "M238.689 58.8v1.65l6.76 11.47 2.01.19 4.66 4.87 8.58 2.56h2.38",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2862",
    d: "m250.879 60.889-.06 1.47h-4.23l-2.33-4.11-2.67.26-1.91.19",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 45",
    transform: "translate(259.809 61.569)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.89 1.44 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2863",
    d: "m251.789 55.009-2.31-1.93-2.61.72 4.16 3.45-.15 3.64 3.32-1.1 5.61 1.78h.01l.88 1.44.55.89",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2864",
    d: "m262.469 72.959.1.28.33.93 1.91 2.4-1.73 2.97h7.49l1.97 2.24v.01h.01l3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41-1.75-1 .08-1.75 2.89-2.05h1.94",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 46",
    transform: "translate(267.829 68.389)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M4.99 0 0 4.62"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2865",
    d: "m284.669 64.649-2.1-.96h-.01l-4.05-1.85",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 47",
    transform: "translate(272.259 55.159)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.74.22 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2866",
    d: "m269.469 61.929-1.31-3.85h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2867",
    d: "m259.189 52.069-4.24-2.9-3.56.82.4 5.01v.01l2.27-.9h3.73l8.8 7.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2868",
    d: "M269.479 61.929h-.01l-2.87-.77h-.01l-5.34 2.74-1.09 2.33 2.31 6.73 5.36.05 4.99-4.61v-.01l1.37-5.93",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2869",
    d: "m269.509 57.689-1.34.39 1.31 3.85 3.83-1.97.88 2.5 4.32-.62-.63-.29-1.26-3.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2870",
    d: "M282.449 54.7h-.01v-.01l-4.09-1.89-6.41.28-2.7 2.23h-.01l-2.78.12-2.88-3.79-3.92.75-.46-.32",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2871",
    d: "m269.239 55.309 3.24-.15h.02l-.23 1.74h-.01l-2.75.79 3.44 1.12 3.66-.35h.01l-.57-1.39 6.39-2.37",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 48",
    transform: "translate(240.399 54.489)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.99.49 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2872",
    d: "m241.6 58.519 2.66-.27-1.85-3.26h-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 49",
    transform: "translate(233.889 52.769)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.08 0 0 .02"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 50",
    transform: "translate(234.019 52.559)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.93 0 0 .2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2873",
    d: "m239.149 56.279 1.25-1.79-4.63-2.1h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2874",
    d: "M233.889 52.8v2.56l3.58.91.05.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2875",
    d: "m238.689 58.8.99-.1 1.92-.18-.01-.01-2.44-2.23h-1.63z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2876",
    d: "m207.489 31.439-.17-.08.01 1.6",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2877",
    d: "m210.049 31.179.24.18-.25 1.16",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2878",
    d: "m207.5 33-.17-.04.01 1.83.13.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 51",
    transform: "translate(210.489 37.769)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.03 0 0 .02"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 52",
    transform: "translate(209.809 29.439)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.33 0 0 .03"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2879",
    d: "m213.909 28.819-.02-.14-.02.02-.74.7",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2880",
    d: "M209.379 29.479h-.17l-.32.82 1.16.88.12-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2881",
    d: "m230.009 44.469.35-.78-.89-.36",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2882",
    d: "m223.429 48.349-1.09 1.13 1.51.85.15-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 53",
    transform: "translate(218.189 49.329)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 54",
    transform: "translate(211.209 39.769)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.04.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2883",
    d: "m195.829 30.419-.07.11 2.73 3.15.5.57.1-.08",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2884",
    d: "m210.289 15.209-3.42.18-1.45.07-16.71 11.57 1.67 3.92.16-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2885",
    d: "m195.429 30.149.32.38.07-.11",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2886",
    d: "m212.759 15.079-2.47.12v.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 55",
    transform: "translate(212.769 15.079)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2887",
    d: "m209.329 20.449-2.67 6.05 3.12 1.58h.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2888",
    d: "M354.369 44.329h1.64l-5.8-5.93-1.64-.05 4.66 5.75 2.28 4.25h1.69z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2889",
    d: "m207.469 34.849-.17-.05.01 1.35v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2890",
    d: "m234.019 52.769.93-.21.8-.17h.01l4.62 2.1h.02l1.99.5v-.01l-1.25-2.18v-4.45l-2.01-2.51V40.9h15v-3.83h.02v-.01l8.44-1.89 21.47 7.57 3.68 2.15.02-.01v-.01l4.52-3.43 6.07 1.85.01-.01 1.63-3.69H300l14.93 3.7h7.32v-.01l2.72-.54v-.01l-1.46-5.15h6.4l6.57 6.44 8.95 2.28v7.21h.01l3.91-.68 2.11-3.15v-5.85l-6.03-6.85-5.84-.09 1-7.21 12.05.09 1.31-4.09 5.08 1.92.02-1.89 1.26.13 2.19 2.1-2.11 1.45-.26 4.31 8.58 8.12v-7.85l-4.84-4.66 11.47-3.63.14-1.17-5.76-1.57 2.24-1.75 5.16 1.06 3.5.07-2.81-3.01-18-3.56-27.9-.8-1.57-2.13-9.73-1.59-2.74 2.46h-7.88l-3.28-2.46H288.9l-1.1-3.93h-16.44l-14.49 6.48 3.17 3.93-2.74 2.83-2.47-8.09-4.37-.34 2.1 4.78-16.9.46-15.65 6.42",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2891",
    d: "m229.049 46.649.61 1.43-1.51.41.27 2.4 5.45 1.91h.02v-.01l.08-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2892",
    d: "m229.469 43.329.87.36-.34.76",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2893",
    d: "m214.519 28.079-.65.6v.02l.02.14",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2894",
    d: "m215.229 14.959-.02-.01-2.44.13h-.01v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2895",
    d: "m217.949 19.869 5.83.22.03-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 56",
    transform: "translate(201.279 47.249)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0 0 .01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 57",
    transform: "translate(192.249 46.159)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.02 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2896",
    d: "m170.829 54.039-.17-.03-.14 5.43 1.37 2.42.76.06v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 58",
    transform: "translate(200.079 41.379)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .01.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 59",
    transform: "translate(199.829 36.629)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2897",
    d: "m203.989 35.7-.04-.03-3.93.96",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2898",
    d: "M207.339 36.149h-.03l-2.58.08",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 60",
    transform: "translate(217.459 51.449)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .02V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 61",
    transform: "translate(215.809 51.049)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .06.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2899",
    d: "m192.619 35.669.35.86-2.65 1.59",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2900",
    d: "M193.449 32.019h-.17l-1.13 2.55.47 1.1h.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2901",
    d: "M196.339 35.3h.49l.01-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2902",
    d: "m196.389 33.6-.05-.05-.88.36-.28 1.4h.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 62",
    transform: "translate(193.699 46.149)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2903",
    d: "M197.609 60.049h-.17v.82l1.23.85 2.06.32V62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2904",
    d: "m192.269 55.469-.17-.05V58.8h1.57v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2905",
    d: "M192.329 50.579h2.2l6.8 6.79.31 2.59.04.3.16-.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2906",
    d: "M193.059 53.089h-.17v1.39l.78.3.01-.07",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 63",
    transform: "translate(179.589 40.629)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M6.53 0 0 3.91"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2907",
    d: "M177.359 44.549h-.17v1l2.82 1.53.38 5",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2908",
    d: "m187.669 39.7-1.55.93.08.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2909",
    d: "m190.309 38.219.01-.1-2.65 1.58.09.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2910",
    d: "M177.239 31.5h-.17v3.46l1.95.18.03 2.1-1.44.79 1.27 1.85-2.57 2.43.21-.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 64",
    transform: "translate(173.819 35.119)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.16.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2911",
    d: "m173.879 35.2-.06-.08-2.54 1.86v3.74h.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2912",
    d: "m172.889 39.459 2.57.35v-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2913",
    d: "M170.879 52.159h-.17l-.04 1.84.16.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2914",
    d: "M172.659 61.909v.01l6 .44.01-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2915",
    d: "M185.939 57.249v-.14l-1.85 1.61h1.85v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 65",
    transform: "translate(205.449 48.239)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 66",
    transform: "translate(199.089 49.809)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2916",
    d: "m235.579 61.069 3.07-.62V58.8l-1.18-2.52-3.63-.92-14.66.48-.76.91-.5.59-2.83-.02 2.33 4.68 10.71.59 4.75-.97 2.7-.54",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 67",
    transform: "translate(215.239 56.279)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2917",
    d: "m203.379 53.249.94.23.04-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2918",
    d: "M206.439 57.309h-.01l1.21 1.39 2.33.65-1.42.6 1.88 2.37.08-.12",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 68",
    transform: "translate(205.439 48.239)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2919",
    d: "m199.909 49.779 2.87 3.32.6.15-.02-.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2920",
    d: "m204.379 53.449-.05.04 1.13.28",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2921",
    d: "m205.509 53.739-.05.03.76 3.3.22.24.13-.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 69",
    transform: "translate(215.809 51.049)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.03.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2922",
    d: "m250 80.319.76-.78-1.33-1.87-.59 1.88",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2923",
    d: "m225.769 63.789-3.05 1.13 2.18.55z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 70",
    transform: "translate(232.129 67.209)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 71",
    transform: "translate(232.449 68.849)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .03.07 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 72",
    transform: "translate(230.589 69.449)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 3.08.53 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2924",
    d: "m250.879 80.9-.88-.58-1.16-.77-.37-.24-3.02-4.93h-1.32v-.01l-.94-1.22",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2925",
    d: "m256 83.639-1.7-.24-.81-.11",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 73",
    transform: "translate(243.119 89.579)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 2.8 5.35 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2926",
    d: "m232.539 68.929-.09-.05-1.33.57h-.01l-.52 3.08-1.72.8-1.14-.14 10.64 18.49.22.69",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2927",
    d: "M242 73.149h1.2l.93 1.22h1.32l-1.6-2.6h-1.51",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2928",
    d: "m234.359 65.879-2.23 1.34.39 1.63.02.08 8.07 4.21 1.39.01.34-1.38 2.97-.01-6.66-11.3-3.07.62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2929",
    d: "M257.429 80.209 256 78.929l-2.26 2.54-2.86-.57 1.19 2.19 1.42.2.8.12",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2930",
    d: "m252.209 90.849 2.11 1.43 6.97-8.64-3.86-3.43L254.3 83.4l-.01.01 1.71.23v3.92l-3.79 1.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2931",
    d: "m227.729 67.7 1.65 1.15 2.75-1.64 2.23-1.33 1.22-4.8v-.01l-2.7.55-4.76.98-.5 2.33",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2932",
    d: "m248.469 89.579-5.35 2.81v-.01l.35-1.43-3.78-.48-1.1 1.9 1.88 6.16 13.85-6.24-2.11-1.44v-2.27z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2933",
    d: "m227.729 67.7 1.24-2.3-1.35-.47-.49 2.33z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2934",
    d: "m227.7 73.259.03-.07V67.7l-.6-.43-.95 3.51",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2935",
    d: "m239.079 151.629 1.44 3.42 3.47.15 5.89-18.9h-2.1l-6.85 7.11-.68 4.93z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 74",
    transform: "translate(200.119 105.189)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 3.65.91 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 75",
    transform: "translate(202.679 112.439)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2936",
    d: "M202.3 113.549h.01l.38-1.1",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2937",
    d: "m192.9 107.419-.43 3.03h1.34l-.06 3.1",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2938",
    d: "M199.559 96.969v2.91l-3.56 7.36",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 76",
    transform: "translate(200.029 102.229)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1 2.95 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 77",
    transform: "translate(196.089 113.549)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.55 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2939",
    d: "m193.689 115.8-.08 3.68 3.09 4.13",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2940",
    d: "M193.689 115.8h2.4v-2.25h-2.34z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 78",
    transform: "translate(185.699 98.989)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.12 0 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2941",
    d: "M186.249 96.969h-.01l-.41 2.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2942",
    d: "m184.079 107.449 3.98.58.54 2.42h3.86l.44-3.03 3.1-.18 3.55-7.36v-2.91",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 79",
    transform: "translate(169.569 101.499)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M3.53.69 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2943",
    d: "M169.4 111.679v.01l7.24-2.1",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2944",
    d: "m166.779 104.159-2.32 2.19 4.94 5.33v-4.56l-.98-1.1-1.64-1.85",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2945",
    d: "M199.109 126.809v9.98l-2.56 4.2.23 2.74",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2946",
    d: "m204.139 128.739-.56-1.96h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2947",
    d: "M210.519 131.759v-4.55H207.7l-.57 2h-.01l-2.81.1v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2948",
    d: "M176.639 102.889v6.7l4.92-1.42",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2949",
    d: "M206.629 112.449h-3.95l-.38 1.1h-3.66l2.02 6.53H196.7v3.53l1.55 2.07 3.78-1.72v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 80",
    transform: "translate(232.849 88.209)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M5.93 10.18 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "m162.1 103.809 2.36 2.54 2.32-2.18",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 81",
    transform: "translate(236.999 99.879)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 1.51 1.67"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2951",
    d: "m240 100.479-.73-1.25-.49-.84-.89.75",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 82",
    transform: "translate(227.499 134.769)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2952",
    d: "m223.559 156.409 1.56-.03.1-.76 3.24-2.26-.24-6.81 7.6-6.24-.75-7.11",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2953",
    d: "M223.559 150.8v5.08",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2954",
    d: "M227.6 139.389v-.01l-.23-.18-1.6-1.32-.05.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2955",
    d: "M236.639 113.229v6.82l14.75-17.16-.6-3.01-10.25 1.52-.54-.92-1.49 1.07 1.51 1.7",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2956",
    d: "M212.549 143.729h-15.78l5.63 15.85h5.66v-5.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 83",
    transform: "translate(214.599 143.729)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.98 1.36 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2957",
    d: "m227.079 118.289 7.07 4.66 2.48-2.9v-6.82h.01l2.73-2.28",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2958",
    d: "M228.239 116.239v.01l-1.16 2.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 84",
    transform: "translate(227.859 109.999)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.58 0 0 .36"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2959",
    d: "M227.5 131.039h.01v3.73l7.56-1.57h.01l-.93-10.25-7.07-4.67v.01l-.44.77h-2.55l.66-1.13",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 85",
    transform: "translate(220.989 120.549)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.54 0 0 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2960",
    d: "M169.159 75.729h-.01v2.15",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2961",
    d: "m172.039 92.679-.7-12.35h4.04l-6.22-4.59",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M164.4 93.419v-.01h7.68",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2963",
    d: "M158.219 85.049h-.01l-.18 5.42",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2964",
    d: "M164.959 77.879h-.01v4.83l-1.55 2.34",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 86",
    transform: "translate(220.639 117.929)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.71 0 0 3.02"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 87",
    transform: "translate(222.539 117.929)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 2.62 1.05 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2965",
    d: "m220.989 124.379 1.55-3.83h-.01l-1.89.4-.52 2.19",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 88",
    transform: "translate(166.139 98.989)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.87 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2966",
    d: "m159.639 101.149 2.46 2.66 2.3-2.31 2.38 2.66v.01l1.64 1.85 1.15-1v-3.53",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2967",
    d: "m186.689 88.659-11.3-8.32h-4.04l.69 12.34.04.73v.01H164.4v1.64",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 89",
    transform: "translate(173.099 93.139)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 5.5 13.59 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2968",
    d: "M166.139 98.979h2.87v.01l.56 2.5 3.53.7",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2969",
    d: "m225.719 131.039-1.05-1.47-4.56.69-.82 3.69",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 90",
    transform: "translate(222.259 137.919)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 2.41 3.46 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2970",
    d: "m213.019 133 .1 3.97h-3.15v3.56l2.58 3.2h2.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2971",
    d: "M222.019 135.049h.01l-.96 1.92",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2972",
    d: "m218 148.5-2.42-3.41h-7.52v9.32l2.28 2.63 9.3-6.23v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2973",
    d: "m184.729 99.389-4.14-3.77h-.01l-7.48 3.02v3.55l3.54.7v-1.9h3.75",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2974",
    d: "M225.719 131.039v6.88l.05-.03 1.6 1.31.23.19v3.2l1.83-1.6v-2.74l-1.93-1.28v-5.93z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2975",
    d: "m230.429 109.989.01.01.91.95h8.03l6.67-5.56-6.03-2.14-3.019-3.37.89-.74-2.34-3.7h-5.76l-4.07 9.62",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2976",
    d: "M221.349 117.929h3.4l.97-1.69h2.52l.36-2.7-.74-3.18-4.87.68",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2977",
    d: "m185.829 98.979.42-2.01h13.3l3-6.16",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2978",
    d: "M184.729 99.389h.01l1.08-.4h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2979",
    d: "M186.689 88.659v4.48l-6.1 2.48 4.14 3.76",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2980",
    d: "m164.529 74.959-6.24 8.13-.07 1.96h5.18l1.56-2.34v-4.83h4.2v-2.15",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 91",
    transform: "translate(164.949 74.959)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M4.21 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2981",
    d: "M161.709 98.989h4.43v-.01l-1.74-3.92-6.37-4.59-.19 5.28",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2982",
    d: "m157.8 96.969-.08 2.02h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2983",
    d: "M157.8 96.969h4.23l-4.19-1.22z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2984",
    d: "m201.369 82.709 1.18 8.1-2.99 6.16 2.47 5.26h-2.01l1 2.96h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2985",
    d: "m210.959 95.389 2.21-2.18V93.2",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 92",
    transform: "translate(202.989 100.499)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 3.76 7.97 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 93",
    transform: "translate(213.589 83.629)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01.01 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2986",
    d: "M195.609 82.709h9.16l8.62 5.53",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 94",
    transform: "translate(193.259 67.549)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M3.61 0 0 3.88"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2987",
    d: "m214.239 69.159-5.02-.68-2.08 3.1-4.57-.91-1.81-2.2-3.88-.93v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2988",
    d: "M179.569 64.579v-.01l-.5.05-7.17.75-7.37 9.59h.42l3.48-.01h.73",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2989",
    d: "M169.159 74.339v-.01l10.41-5.68",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2990",
    d: "m191.329 62.149-5.03-.14-6.73 2.57v4.07l-10.41 5.69v1.39l17.53 12.93 8.77-5.95h.15l-2.35-11.28",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2991",
    d: "m191.329 62.149 1.93 9.28 3.62-3.88h-.01l-1.41-.34.17-4.94z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2992",
    d: "m214.6 143.729.97 1.36L218 148.5l1.64 2.3h3.92l2.16-5.05v-3.16l-3.46-2.26-4.89 3.4z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2993",
    d: "M216.909 163h2.01l1.19-1.24v-1.59h-1.64l-1.56 1V163z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2994",
    d: "M223.559 155.879h-1.53v1.4l1.53.92v-2.32z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2995",
    d: "M229.319 82.129 223.9 72.8l2.97 2.42.8-1.89.03-.07-1.52-2.48-11.94-1.63v.01l-.64 14.47h13.09z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2996",
    d: "m222.989 111.039 7.44-1.05-4.71-4.93-.01-.01 4.08-9.61v-.01l3.06-7.22V88.2l-3.53-6.07-2.63 1.51h-13.1l-.2 4.6-.22 4.96-2.21 2.18v5.11",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2997",
    d: "m210.959 100.5 7.82 9 .01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2998",
    d: "M206.969 109.839h-.01l-.33 2.6v.01l-.63 4.91-3.97 6.59-3.78 1.73.85 1.13h.01l4.46-.03.57 1.96.17.56 2.81-.09.57-2.01h2.82v4.56h.01l2.5 1.24 8.05 3.97.95-1.92-2.73-1.1h-.01l.83-3.69v-.01l4.56-.68-3.68-5.19-.87-1.24-.01-.01 1.24-5.2 1.64-6.89-4.2-1.53-11.49.32",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2999",
    d: "m201.029 105.189-.92 3.64.01.01 2.55 3.6h3.97l.33-2.6.33-.01 11.48-.33h.02l-7.84-9v-.01l-7.97 3.77-1.96.92z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3000",
    d: "m183.339 107.659.74-.21 1.62-7.86.13-.6v-.01l-.01.01-1.09.39v.01l-2.61.96",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3001",
    d: "m182.119 100.349-1.73.64 1.17 7.18 1.78-.51z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3002",
    d: "m159.639 101.149 2.07-2.16h-3.98l-.01.09z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2649"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2648",
    style: {
      clipPath: "url(#y2qah60fbb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3003",
    d: "M10.4 20.139h-.01l-1.4 1.96H9l6.23-.23-.03.01-7.99 3.01H7.2l-3.89 5.26h.01l3.33-.06-.02.01-6.38 4.19",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3004",
    d: "M17.8 17.309h-.01v2.92",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 95",
    transform: "translate(40.629 14.569)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M3.05 1.27 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 96",
    transform: "translate(43.709 15.849)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 97",
    transform: "translate(57.829 90.469)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .3 2.32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3005",
    d: "M59.839 90.159h-2.05v.01l.01.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3006",
    d: "m54.649 94.839 3.34 1.68.73-1.31 1.57-2.84",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3007",
    d: "M55.739 92.789h-.01L54.6 94.8l-.01.01.01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3008",
    d: "m58.769 95.139-.05.07v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 98",
    transform: "translate(59.139 93.209)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.71 0 0 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 99",
    transform: "translate(60.399 97.609)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .61.27"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3009",
    d: "m58.719 95.229-.73 1.29.01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 100",
    transform: "translate(58.719 95.219)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.44.65 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 101",
    transform: "translate(60.389 96.149)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.45.41 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3010",
    d: "M59.839 90.159v.01l.01.03.44 2.17.01-.01 2.15-4.06",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3011",
    d: "m61.739 97.269-.73.61v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3012",
    d: "m63.169 100.789 3.69.39-.18-8.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3013",
    d: "m72.039 114.879-2.61 3.29-.31 5.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3014",
    d: "M72.129 124.639h.01l5.39-6.61.01-.01-5.13-2.93",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3015",
    d: "M82.719 106.929h-.01l-2.08-2.3-.37-4.48",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3016",
    d: "M84.579 122.049h.01V114l2.91-.19v-6.39",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3017",
    d: "m74.409 108.739-.6 3.89-1.78 2.25h.01l.37.21 5.11 2.93h.02l7.04 4.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3018",
    d: "m74.519 105.239.08.25-.82 1.14v.01l.44 1.47",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3019",
    d: "M74.159 103.989h-.01l.04.12.31 1.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3020",
    d: "M80.229 99.779v-.01l-1.47-.01-3.05 4.13",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2651"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2650",
    style: {
      clipPath: "url(#y2qah60fbb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3021",
    d: "m100.159 197.409 1.87 1.72 5.77.21-6.22-3.25z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3022",
    d: "m90.049 150.5-1.55 14.38 3.26 14.24 2.94 5.24.14 3.93 4.37 6.69 1.59.17-.82-17.13 9.27-4.01-4.2-5.85",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3023",
    d: "m96.209 149.789-.39.71h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3024",
    d: "M103.119 157.479v-3.01h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 102",
    transform: "translate(106.509 155.959)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.51 0 0 1.52"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3025",
    d: "m105.049 161.719 4.09-4.2-.11-1.57h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3026",
    d: "M105.049 161.729v6.43l5 1.84 2-3.48-7-4.8",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3027",
    d: "m96.269 110.029 1.24-6.07v-.02l-1.4-1.34-5.58-.55-3.1-2.21-7.2-.06.03.37.38 4.48 2.08 2.3 4.78.49h.01v6.39",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3028",
    d: "M92.349 114.929h.01l-.25-3.37 4.15-1.53",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3029",
    d: "M88.269 113.759h.01l.97 2.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3030",
    d: "M66.889 102.339h-.01l-.03-1.15",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 103",
    transform: "translate(66.519 102.939)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.49 1.14 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 104",
    transform: "translate(66.509 104.429)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3031",
    d: "M63.169 100.8h-.01l2.46 3.32",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3032",
    d: "m98.059 109.609-.24 4.96 4.16-.47v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 105",
    transform: "translate(96.269 109.369)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .66 1.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3033",
    d: "m101.839 108.079-4.33-4.12-.02-.02-1.23 6.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3034",
    d: "m98.049 146.389.01-.01 4.34-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3035",
    d: "M90.039 150.5h5.77l.39-.71",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 106",
    transform: "translate(86.839 134.349)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3036",
    d: "m109.329 111.029-1.1-2.4-2.33-.2",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 107",
    transform: "translate(105.719 113.369)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .32 2.79 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3037",
    d: "m102.4 146.359-4.35.03-1.85 3.4h.01l6.9 4.68v3.01h3.4l2.51-1.53",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3038",
    d: "m101.979 114.089 1.7-.18 2.04-.22v-.01l.18-5.25-4.06-.36v.01l-1.28 2.37z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3039",
    d: "m80.839 123.969-1.65 5.38 6.26 5.39 1.39-.39 4.25-1.2 3.81 3.91 7.4 6.05.1 3.25.12 3.83 6.33 3.37.17 2.39v.01l.11 1.56-4.09 4.2h.01v.01l7 4.79 4.08-7.12.96-6.17 9.92-4.39 1.84-13.71 4.28-5.6v-3.38l-7-4.55-6.85-.42.18-1.87-3.16-1.37-3.17 1.85 1.03-2.77-2.1-.91-2.98 2.3 2.17-3.2-1.92-4.18-.82 2.34-2.79.31-2.04.23-1.7.19-4.15.46.23-4.95.01-.24v-.01l-1.8.67h-.01l-4.17 1.53.26 3.37-3.1 1h-.01l-.97-2.17-.76.05H87.5l-2.91.2h-.01v8.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3040",
    d: "m74.179 103.989-.43-1.57v-.01l-3.29.29-1.17.97",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3041",
    d: "m73.779 106.619.81-1.14-.07-.24-.02-.08-.29-1.08-.02-.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3042",
    d: "m70.169 105.739.89-1.32 2.1.2v.01l.61 2.01.01-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3043",
    d: "m67.749 102.819-.09.12-1.15 1.49h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3044",
    d: "M86.839 144.059v-9.7l-1.4.39-6.26-5.39 1.66-5.39 3.74-.46v-1.46l-7.05-4.02-.01-.01-5.39 6.62-3.01-1.45h-.01l-.1 1.55 9.18 15.64 7.94 5.32",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3045",
    d: "m86.129 145.7 1.33 32.54 3.51 2.84.17 5.83 6.09 7.88 1.97.2-4.37-6.7-.14-3.93-2.94-5.23-3.26-14.25 1.55-14.37v-.01l-3.2-6.44z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3046",
    d: "m83.359 89.779 1.38-1.03h2.21l.54-.79.01-.01-4.14-.46",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 108",
    transform: "translate(80.109 89.219)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h3.25"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3047",
    d: "M83.359 87.5v-.01h-2.59l.01.01.83 1.19",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3048",
    d: "m27.379 68.293-3.7-3.9v-8.82l10.87-11.46h33l3.84 1.75.03.02-.76 1.65h1.87l1.6-.78 1.19.73.08.05 2.7.09v.01l.23.76-4.09.88-.1.17.1-.17v-.188l4.09-.692-2.7 1.97 1.65-1.1H78.7v.01l-.37 3.14 1.3-.13.53-.05 1.79-1.39h4.15l1.96-1.35h6.35l2.73-2.36.01-.01h2.46v.01l-.22.67-.65 2.08-.02.06h-.01l-1.56.27h-.01l-23.09 19.75-.06 8.88h-.01l-2.26-.06-.94-7.13v-.01l-14.27-.04-5.985 7.635-3.283-6.38H43.3l-1.633-2.895",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3049",
    d: "m42.269 71.249-.74-1.11-13.87-1.79",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3050",
    d: "M86.1 50.839h1.51l-2.11 1.44H84z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3051",
    d: "m54.629 94.829-.03-.01.01-.01 1.13-2.02h2.4l-.31-2.32-.03-.26-.01-.04h2.06",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3052",
    d: "m58.819 95.049.32-.59 1.16-2.08",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 109",
    transform: "translate(57.999 95.229)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.3.72 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3053",
    d: "m58 96.529 2.39 1.07.01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3054",
    d: "M60.3 92.369v-.01l-.44-2.16-.01-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 110",
    transform: "translate(59.849 88.189)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.66 0 0 1.98"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3055",
    d: "m62.459 88.289.05-.1.01-.01v-.01l-2.68 1.99",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3056",
    d: "M60.3 92.379v-.01l2.15-4.07",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3057",
    d: "m60.4 97.609.41-1.46h-.01l-.64-.28-1.44-.64",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 111",
    transform: "translate(60.399 97.609)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .61.28"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3058",
    d: "m61.009 97.889.73-.62 4.94-4.13",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 112",
    transform: "translate(66.679 93.139)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.19 8.05 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3059",
    d: "m61.009 97.889 2.16 2.9v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3060",
    d: "m66.679 93.139-6.83.07-1.03 1.84-.05.09-.05.08v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3061",
    d: "m73.789 106.649.43 1.46.19.63",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3062",
    d: "M75.719 103.889h-.01l-1.52.1h-.03l.03.12.31 1.05.1.33",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3063",
    d: "m66.509 104.439-.88-.31-.01-.01-2.45-3.32 3.68.39h.02l.02 1.15.86.48.01.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3064",
    d: "M66.519 104.439v-.01l1.24-1.6",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3065",
    d: "m66.519 104.439 3.65 1.3.02.01.88-1.32 2.09.2h.01l.61 1.99v.01l.01.02.81-1.16-.38-1.4-.03-.1-.43-1.57h-.01l-3.28.29-1.17.97-.01-.01-1.53-.84",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3066",
    d: "m83.359 87.5 4.13.46h.02l-.55.8h-2.21l-1.39 1.03v-.56",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3067",
    d: "M83.359 87.5v1.73h-3.25v-.54h1.51l-.84-1.19z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3068",
    d: "m82.339 53.419-2.13 1.47h-2.59l.01-.01 2.12-1.46h2.59z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "#038B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3069",
    d: "M110.819 45.9h8.06l-1.68-2.67h-.01l-.02-.01-1.48-.35v-1.92l-.01.01-.04.04-4.78 4.86z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3070",
    d: "m57.989 96.529-3.34-1.68v-.01l1.13-2.01h2.4l-.34-2.63H59.9l2.55-1.9.01-.01.11-.08.11-2.9-2.93-.06-2.32 3.82-6.39.01v-.01l-3.11-6.69 2.58-3.24v-.01h-.01l-3.21-6.32h-.14l-3.76.13-1.12-1.69-.73-1.11h-.01l-13.88-1.8v.01h.01l.02.02.59 6.25 4.27 8.08 1.75-1.35-3.37-7.18v-4.04h1.99l.07 3.76 6.38 14.98 10.4 4.34 2.6-.69L54.6 94.8l.01.01.02.02.02.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3071",
    d: "m127.979 4.819-5.72 1.76V8.5l9.45.13h.14l2.45 4.24.01.01v3.83h-.01l-4.59 2.62.13 5.2 2.89 2.91.01.01h3.41l5.23-5.52 7.37-2.18 2.76-2.11 5.57-.35h.01l3.89-1.15h.01l7.36-11.7 4.52-.93h.01l1.6-1.6h-.02L162.719.719l-1.31-.13h-.01l-11.28 1.32h-13.69l-7.88 2.74z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2653"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2652",
    style: {
      clipPath: "url(#y2qah60fbb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3072",
    d: "m43.7 15.839-3.07-1.27-16.26.09-6.57 2.65v2.92h-.01l-7.39-.09L9 22.1l6.2-.22h.04l-8.03 3.01-3.89 5.26 3.31-.05h.03L.25 34.29l2.34.19 12.24-5.85 14.12-.49 4.28 4.27.02.02 1.62-1.74-1.42-1.47h-1.6l-1.56-1.78 13.42-11.59v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 113",
    transform: "translate(43.719 15.839)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 114",
    transform: "translate(43.719 15.849)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3073",
    d: "m33.089 43.029-2.23-1.83-.96.82 1.56 2.04h1.63z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3074",
    d: "M110.859 45.859h7.97l-1.66-2.63v-.01l-.02-.03-1.46-.35h-.01l-.04-.01v-1.92l-4.88 4.95h.1z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3075",
    d: "M104.049 22.739h2.7l3.87 3.2 1.06-.46-.92-2.03 2.66 1.26.87-.37v-3.98l3.06 1.09 1.76-1.17-.99-1.86-1.77-.64-.08-2.81-9.81-4.01-1.46-.02-3.41 2.8 1.14-2.82-1.65-.01-3.98 4.22 2.06-.11 7.6-.41 5.89 5.27-3.96-.06-2 1.63h-4.5v1.29z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3076",
    d: "m71.4 45.839 6.57-1.39.82 2.91 1.33.98 2.23-.16.87 2.62h2.83l1.96-1.35h6.35l2.74-2.37h2.46l-.01.04-.01.01-.87 2.76.06-.01h.01l4.31-.75-2.87 1.37.27 1.19 7.81-2.74-3.81-.18-1.78-1.6 1.76-2.73-.86-.82-5.52 2.5v-1.44l5.28-2.54 8.47-.36 6.36-3.39.03-1.54-4.63-.8-.57-7.58-6.06 2.39.04-3.57-2.92-2.49h-3.98l-10.74 15.64h-2.6l.05-5.14-9.25-5.02 9.25-6.85 5.25-.96-1.1-1.62 8.08-.89 3.29-3.42-3.08-.35L94.969 19l.48-2.4-1.98-.2L93 13.5l-3.44 1.52.9 1.85-4.6 2.19-8.01-1.5-4.23 1.98-10.29-4.11-19.61.41h-.04l-13.43 11.6 1.56 1.79h1.6l1.42 1.46-1.6 1.72-.02.03-1.65 7.52 2.95 2.67v1.44h33.01z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3077",
    d: "m95.069 21.449-2.52 2.05 4.98.53.53-1.29z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3078",
    d: "m85.359 16.249.92 1.2 2.35-1.2-.7-1.11z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3079",
    d: "m87.139 12.229 1.5 1.51 3.21-1.07.84-2.25z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3080",
    d: "m93.269 11.329.41 1.43 4.38-1.16-.89-1.17z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3081",
    d: "m104.429 8.349-2.4-1-2.329 1.99 9.45.74 2.47-1.73z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2655"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2654",
    style: {
      clipPath: "url(#y2qah60fbb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3082",
    d: "m127.439 3.039 4.93-2.79-19.58 1.46v1.05l6.61-.13-.93 1.23-6.85.14.89 1.57-2.95-.48 1.17 1.51h-5.07l.76.75h5.54l.89.76 8.08-3.77z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3083",
    d: "m103.469 4.179 3.65.69 2.09-1.34L107.7 2.4z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3084",
    d: "m64.939 13.749 8.57-2.92-1.97-.91-8.1 2.06z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3085",
    d: "M74.619 11.369 70 12.939l2.72 1.14-4.25 1.09 5.28 2.05 3.63-1.58 4.04.96 3.03-.7-2.96-1.36 2.28-2.95h-2.28l-1.37 1.78-.55-1.78-2.42.94z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 115",
    transform: "translate(80.109 87.219)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3086",
    d: "M67.919 83.519h4.21l3.4 2.26-1.3 1.44h5.88l-7.03-5.07h-3.72z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3087",
    d: "m73.819 89.819.88.75h2.54v-.89l-.89-.89h-2.53z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3088",
    d: "m89.419 89.119-.52.85h1.42l.52-.85z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2657"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2656",
    style: {
      clipPath: "url(#y2qah60fbb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3089",
    d: "m394.889 177.269-.85 2.72 6.21-4.42-1.79-2.38v-2.72l-1.02.42v3.83z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3090",
    d: "m378.559 186.2 12.93-6.55v1.7l-9.95 6.55z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3091",
    d: "m325.569 152.6 10.89-5.1 8.08-8.93 4.42 1.96 1.96-4.08 7.4-.17-1.87 3.4 6.12 5.27 4.08-4.08v-5.7l1.88.59 2.12 10.21 6.64 9.35-.68 7.06-12.08 12.5-10.46-.6-1.28-7.06-3.57 1.53-3.4-2.97-20.67 4.52-1.28-1.53 1.7-4.09z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3092",
    d: "m200.559 64.839.17.04.01-1.82h-.17l-1.9-.06-.02 1.35z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3093",
    d: "m214.3 31.689-1.17.35-.05-.03h-.01l-1.9-1.06",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 116",
    transform: "translate(214.469 31.639)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.37 2.6 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3094",
    d: "m210.209 31.179.25.18-.27 1.23-.15-.07-2.55-1.16v.08l.01 1.52",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3095",
    d: "m213.809 35.109-.1-.05h-.01l-2.53-1.16-3.67-.94V33l.01 1.79 2.05.68.56 1.16.4 1.14.04.1",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 117",
    transform: "translate(218.919 38.959)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.27.93 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3096",
    d: "m214.839 34.239-1.03.87-3.25 2.76.68 1.88 6.04.96h.02l.07.01 3.71-.8",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3097",
    d: "m220.119 38.189.17-.1-2.37-3.85h-.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3098",
    d: "m209.379 29.479-.32.82 1.11.85.04.03.85-.2.11-.03 1.89 1.06h.01v.01l.06.03 1.17-.36h.01l.15-.05h.01l-.41-2.96-.02.02-.13.12-.02.02-.6.56h-.16l-1.99.04-1.33.03z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3099",
    d: "m221.179 39.889-.09.02-.01.01-3.71.81-.09-.01v-.01h-.03l-6.01-.96.01.03.37 1.03-2.2 2.74V45.1",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3100",
    d: "M229.209 46.609h.02l.87-1.96.43-.96-1.11-.45-8.22-3.35h-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3101",
    d: "m217.119 48.889 1.07.44.15.06.34-1.04h4.92l-1.09 1.13 1.49.84.02.01 2.04-.16-1.93-2.47 4.92-1.05.16-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3102",
    d: "M210.409 45.1h7.31l.8 1.51-1.44 2.26",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 118",
    transform: "translate(207.099 16.779)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.76 1.84 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 119",
    transform: "translate(208.589 20.389)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.03.06 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3103",
    d: "m195.919 30.529 3.17 3.64.07.08 5.27-4.66-2.47-3.07 5.56-6.07h1.09",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3104",
    d: "m210.459 15.209-.17.01-3.42.17-1.28.07-16.71 11.57 1.66 3.89.01.03 4.88-.8.15-.02.24.29h.01l.09.11 1.19-1.85v-5.6l8.59-6.3h1.41",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3105",
    d: "m212.929 15.079-.16.01h-.01l-2.3.11v1.58h-3.35l.75 1.84.73 1.77.02.06h.89l-2.67 6.05 3.12 1.58h4.75l2.6-3.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3106",
    d: "m217.359 25 .01-.01-4.43-9.91",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3107",
    d: "m210.069 36.629-.55-1.15-2.05-.69v.07l.01 1.29v.01l2.41.45h.05l.11.02.03.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3108",
    d: "m229.419 43.249 1.09.44-.42.94-.88 1.98v.01l.62 1.46-1.51.41.27 2.4 5.38 1.88v.01l.07.02-.02-.03v-.01l-3.92-8.11-.01-.02-.08-.16-.01-.02-.53-1.12-.01-.01-.04-.07",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 120",
    transform: "translate(229.419 43.239)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3109",
    d: "m229.419 43.239-6.47-13.39 3.12-8.49-6.03 2.47-.03-.06-2.06-3.9v-.01l5.86.21.14.01 2.93-1.46-11.5-3.67-.15.01-2.29.12h-.01l4.43 9.92-.06.07-2.61 3.01-.65.6v.02l.42 2.94.36 2.6h3.08l2.37 3.85-.15.1-1.2.77-.02.01 2.28.92h.01l8.23 3.35",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3110",
    d: "m207.809 47.829 2.6-2.73h-1.03v-.65",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3111",
    d: "m202.049 47.479 2.41.9h.02l.01.01.04.01.82-.14.09-.02h.01l.16-.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 121",
    transform: "translate(201.449 45.519)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M2.11 0 0 1.74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3112",
    d: "M203.559 45.519h.01l5.64-1.04.05-.01.12-.02h.01v-.9",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3113",
    d: "m202.009 44.029 1.53 1.46.02.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3114",
    d: "M193.869 46.159h-1.6l-.91.41-.04.02",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 122",
    transform: "translate(194.469 47.959)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.01.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3115",
    d: "m194.119 48.089.37-.08V48",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 123",
    transform: "translate(190.889 48.269)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 1.76.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3116",
    d: "m200.189 41.359-.1.03-3.21 1h-.01l1.25 1.63",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3117",
    d: "M198.129 44.029h3.88l1.81-1.16.01-.01.06-.04",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3118",
    d: "m170.829 54.039-.14 5.4 1.37 2.42.59.05h.01l.16.01.89-7.43-2.88-.48v.03z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 124",
    transform: "translate(216.969 48.709)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .02.04"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3119",
    d: "m217.019 48.809.02.05.01-.01 1.43-2.24-.79-1.51-.01-.01h-2.46",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "M210.079 36.639v-.01h-.03l-.11-.02V36.6l-.05-.01-2.41-.44h-.14l-.03.01-2.57.08-.01-.01-.61-.56-.13.03-3.8.93h-.35l.35 4.73 3.7 1.46h.01l.22.09 5.12.62.03.01.12.01 2.19-2.74-.37-1.04-.01-.02-.68-1.88-.03-.08z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3121",
    d: "m210.149 51.7 5.43-.63.23-.02.15-.02 1.5.42.16.04.68-2.1-.11-.05-1.07-.45-.04-.02-.03-.01v-.01l-.03-.04-.03-.06v-.01l-.02-.03v-.01l-1.75-3.6v-.01h-4.8l-.01.01-2.59 2.73",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3122",
    d: "m198.119 44.019-1.24-1.63-.01-.02 3.21-.99.1-.03-.35-4.72v-.01l-2.34-.02-2.15-.02-.56-.01-.23-.9",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3123",
    d: "m199.049 45.249-.06-.07-.85-1.14",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3124",
    d: "m196.329 46.049.97-.28 1.74-.52",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3125",
    d: "M191.239 46.559h-.01v.04l-.01.03h.01l.09-.04.04-.02.89-.41.02-.01h1.6",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 125",
    transform: "translate(191.239 44.239)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.47 0 0 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 126",
    transform: "translate(190.249 42.699)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 1.61.84"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 127",
    transform: "translate(190.249 41.779)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M.05 0 0 .91"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3126",
    d: "m192.789 35.669.35.86-2.65 1.59",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3127",
    d: "M192.789 35.669h1.76l-.05-.2-.04-.18.58-3.25h-.17l-1.42-.02-1.13 2.55z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3128",
    d: "m197.509 34.529-1-.98-.12.05-.76.31-.28 1.4.99-.01.5-.01H197z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3129",
    d: "M203.569 45.509h-.01l-.01-.02h-.01l-1.53-1.46-.01-.01h-3.88v.01h.01l.01.01.85 1.14.05.07h.01v.01l-1.75.51-.97.28-.32.1h-2.14v.01l.6 1.8h.01v.01l.01.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3130",
    d: "M197.729 47.249h3.72l1.56-1.28.55-.45v-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3131",
    d: "M200.9 60.049h-3.29v.82l1.23.84 1.89.29.17.03z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3132",
    d: "M193.669 58.789h.17v-2.92l-1.57-.46v3.38z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3133",
    d: "m201.839 60.169.01.08 1.25-.73.39-2.07 1.55-.32-8.3-7.18 2.2-.13.15-.01-.66-1.24-.69-1.31-.01-.01-.04.01-.11.03h-.01l-3.08.71-.37.09-1.34.31-.13-.01-1.75-.14h-.01v.02l-.01.01v.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3134",
    d: "m190.619 49.589-.03.12 1.9.86",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3135",
    d: "M193.059 53.089v1.39l.62.23.16.06.35-1.68h-1.13z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3136",
    d: "m201.839 60.169-.34-2.81-6.8-6.79h-2.21l-1.89-.87.02-.11.26-1.28.01-.03v-.01l.01-.02.33-1.62V46.6l.01-.04v-.02h.01l.46-2.3.15-.7v-.01l-1.61-.84-.16-.09h-.01l-.66-.35-.09-.04h-.01l-3.02-1.59h-.01l-.09.05-6.44 3.87h-.17l-2.23.01v1l2.82 1.52.38 5 4.06 2.61",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3137",
    d: "m184.739 54.749 1.29-1.67 5.96.04h.17l.17-2.54v-.01h.16",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3138",
    d: "M190.289 41.779h.01l.04-.76",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 128",
    transform: "translate(190.279 41.789)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0h.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 129",
    transform: "translate(189.419 42.039)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .21.39 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3139",
    d: "m187.839 39.7-.08.05-1.46.87-.01.01 3.03 1.58.09.05",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3140",
    d: "m190.339 41.019.15-2.9-.18.1-2.47 1.48 2.33 1.23h.01z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3141",
    d: "m189.409 42.259.67.35.17.09v-.01l.04-.9v-.01l-.01.01-.16.08v.01l-.31.16-.39.21z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3142",
    d: "M177.239 31.5v3.46l1.95.18.03 2.1-1.44.79 1.27 1.84-2.53 2.4-.04.04 3.39-.62 3.46-.55.22-1.26h.7l.16-1.42-2.24-.47-2.8-6.43h-.17z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3143",
    d: "m174 35.129 1.38 1.86.04.05h.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3144",
    d: "m175.429 37.029 1.06-.37v-1.37l-2.5-.17",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3145",
    d: "m173.879 35.2-2.43 1.78v3.74l1.27-.01h.17v-1.28l2.57.36.17.02-.2-2.77v-.01l-.03-.04-1.4-1.86-.01-.01-.01.01z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3146",
    d: "m170.879 52.159-.04 1.84 2.88.48-.89 7.43 5.84.44.16.01 5.92-7.6-.01-.01-.11-.07h-.01l-4.06-2.6h-.17l-9.51.07z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3147",
    d: "M185.939 58.709h.17V57.1l-.17.15-1.68 1.46z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 130",
    transform: "translate(207.809 54.189)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "m0 0 .19 2.46"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 131",
    transform: "translate(208.169 55.629)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 1.17 3.65 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3148",
    d: "M207.789 54.159h.01l.02.03 2.96-.58h.01l.15-.03h.01l-.03-.06-.77-1.81V51.7l-.01-.01v-.01l-2.32-3.85h-.01l-.14.03-2.06.35v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 132",
    transform: "translate(206.309 52.089)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3149",
    d: "m202.039 47.489.01-.01-.6-.22h-3.73l.71 1.31.67 1.24h.01v.01l.09-.01h.08l.18-.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 133",
    transform: "translate(199.469 49.789)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M0 .01.01 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3150",
    d: "m215.219 54.529.03 1.75h2.61l-1.05-2.27h-.01l-.02.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 134",
    transform: "translate(215.219 54.059)",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    },
    d: "M1.44 0 0 .46"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3151",
    d: "m205.8 49.239-.17.02-3.7.5v.01",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3152",
    d: "m203.549 53.249.81.2h.02l.11.03 1.71-1.3v-.01l.11-.08-.51-2.84",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3153",
    d: "M206.609 57.309h-.01l1.21 1.39 2.33.65-1.42.6 1.79 2.25.09.12 1.18-1.87-1.32-2.88 2.62-1.29h2.16l-.02-1.75v-.01l-.17.05-3.23 1.05-3.65 1.18-.15.05-.05.02-.67.22",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3154",
    d: "m205.349 48.259-.82.15-.04-.02h-.03v-.01l-2.42-.89-.02.04-.01.01-.77 1.33-1.76.92-.01.01h-.01l-.01.01.46-.03.16-.01 2.88 3.33.41.1.19.05-1.62-3.48 3.7-.5h.01l.16-.02v-.01l-.19-1.02-.16.03z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3155",
    d: "m206.989 53.039-.68-.94-.1.08h-.01l-1.7 1.31 1.01.25.12.03",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3156",
    d: "m205.629 53.769.76 3.3.18.2.04.04.69-.22.67-.22.05-.01V56.8l-.02-.15-.18-2.45v-.01h-.01l-.02-.03-.8-1.12-.12.06v.01z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3157",
    d: "m211.819 55.629 3.23-1.04.17-.06 1.44-.47.12-.04h.02v-.01l.82-2.5-.16-.04-1.5-.42-.09.01h-.03l-5.69.65h-.01l.78 1.81.02.06.86 1.99v.01l.02.04z",
    style: {
      stroke: "#fff",
      strokeLinejoin: "bevel",
      strokeWidth: ".5px",
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthAmericaUsa);
export default __webpack_public_path__ + "static/media/north_america_usa.b082925f4cc0d0520e0415619896a3dd.svg";
export { ForwardRef as ReactComponent };